import React, { useEffect, useRef, useState, useContext } from "react";
import _ from "lodash";
import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import { Redirect } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Slide from "@material-ui/core/Slide";
import { getServerUri } from "../modules/uriUtility";
import { rolloverCompanySubscription } from "../modules/companySubscriptionApi";
import { perfAsync } from "../modules/playEnginePerf";
import {
  resolvePlayEngineTree,
  buildFlatTreeFromVersions,
  addVersionToTree,
  removeVersionFromTree,
  removeFolderFromTree,
  renameVersionInTree,
  saveHierarchy,
  resolveFolderParentId,
  formatNodeDate,
} from "../modules/versionHierarchyUtils";
import GamePreview from "../components/containerGamePreview";

import GameConfig from "../components/containerGameConfig";
import PlayableGallery from "../components/playableGalleryComponents/playableGallery";
import DialogAccountSettings from "../components/accountSettingsComponents/dialogAccountSettings";
import StickyVersionUpdateWarning from "../components/stickyVersionUpdateWarning";
import BasicPopover from "../components/documentationComponents/Help";
import SelectorGame from "../components/selectorGame";
import BannerSwitchedCompany from "../components/bannerSwitchedCompany";
import { cacheTabRestrictions } from "../modules/editorTabAccess";
import BasePicker from "../components/selectorBase";
import CustomDragComponent from "../components/customDragComponent";
import ImageAccountItem from "../components/imageAccountItem";
import VersionSelectorOptions from "../components/versionSelectorOptions";
import VersionStorageOptions from "../components/versionStorageOptions";

import DialogVersionInsert from "../components/dialogVersionInsert";
import DialogFolderInsert from "../components/dialogFolderInsert";
import DialogVersionDelete from "../components/dialogVersionDelete";
import DialogDeleteAllVersions from "../components/dialogDeleteAllVersions";
import DialogVersionRename from "../components/dialogVersionRename";
import DialogFolderRename from "../components/dialogFolderRename";
import DialogVersionDuplicate from "../components/dialogVersionDuplicate";
import DialogFolderDuplicate from "../components/dialogFolderDuplicate";

import DialogConfirmRefresh from "../components/dialogConfirmRefresh";
import DialogPendingCascadeWarning from "../components/dialogPendingCascadeWarning";
import DialogCircularProgress from "../components/dialogCircularProgress";
import DialogViewOnlyMode from "../components/dialogViewOnlyMode";
import DialogFetchUpdatesOnVersion from "../components/dialogFetchUpdatesOnVersion";

import { UndoContext } from "../contexts/UndoContext";
import useSnapshotEditor from "../customHooks/useSnapshotEditor";
import {
  hasExportAsVersion,
  hasTaskDelivery,
  isSnapshotEditorBase,
  snapshotFlowOf,
} from "../modules/snapshotEditorApi";
import { pushPreviewPatch, buildCommitPreviewPatch } from "../modules/previewPatch";
import { isLegacyBase, isPe3dBase } from "../modules/baseKind";
import { applyVersionPaths as applyVersionPathsToVersion, docKeyFor } from "../modules/versionPathWrite";
import * as persistQueue from "../modules/playEnginePersistQueue";
import { addPersistField } from "../modules/versionPersistFields";
import { startUsageHeartbeat } from "../modules/usageHeartbeat";
import SnapshotList from "../components/snapshotEditor/containerSnapshotList";
import SnapshotPreview from "../components/snapshotEditor/containerSnapshotPreview";
import SnapshotConfig from "../components/snapshotEditor/containerSnapshotConfig";
import usePe3dEditor from "../customHooks/usePe3dEditor";
import Pe3dVariantList from "../components/pe3d/containerPe3dVariantList";
import Pe3dPreview from "../components/pe3d/containerPe3dPreview";
import Pe3dConfig from "../components/pe3d/containerPe3dConfig";

ReactGA.initialize("UA-186063268-1", {
  debug: false,
  gaOptions: {
    userId: localStorage.getItem("user.id")
  }
});
ReactGA4.initialize("G-TB46JQ70PR", {
  debug: false,
  gaOptions: {
    userId: localStorage.getItem("user.id")
  }
});
const useStyles = makeStyles(() => ({
  editorItem: {
    paddingBottom: "10px"
  },
  dialogEditorItem: {},
  textField: { width: "100%" },
  card: { margin: "5px", backgroundColor: "#474747" },
  card2: { margin: "5px", backgroundColor: "#30302f" },

  paddedBox: { margin: "5px" },
  fullWidthEditor: {
    marginBottom: 5,
    width: "100%"
  },
  imageSelector: {
    flex: "1 0 auto",
    marginBottom: 5
  },
  textGameObjectContainer: { marginTop: 0, marginBottom: 5 },
  title: {},
  avatarLarge: { width: "300px", height: "300px", padding: "30px" },
  avatarSmall: { width: "50px", height: "50px", margin: 5 },
  circularProgressDiv: {
    position: "fixed",
    top: "50%",
    textAlign: "center",
    transform: "translate(-50%, -50%)",
    left: "50%"
  },
  sliderSize: {
    width: "100%",
    marginBottom: "5px"
  },
  homeDiv: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    flex: 1,
    overflowY: "auto",
    textAlign: "left"
  },
  emptyContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "6px",
    flex: 1,
    padding: "2rem",
    textAlign: "center",
    opacity: 0.75
  },
  column1: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    borderStyle: "none solid none none",
    borderWidth: "1px",
    borderColor: "black",
    width: "71px",
    minWidth: "71px"
  },
  column1Top: {
    display: "flex",
    justifyContent: "center",
    overflowY: "auto",
    borderColor: "black",
    height: "90vh",
    padding: "5px",

    overflowX: "hidden",
    borderStyle: "none none solid none",
    borderWidth: "1px",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  column2: {
    flex: 1,
    width: "339px",
    minWidth: "339px",
    overflowY: "hidden",
    overflowX: "hidden",

    // position: "sticky",
    // top: "0",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderStyle: "none solid none none",
    borderWidth: "1px",
    borderColor: "black"
  },
  column2Top: {
    display: "flex",
    height: "60px",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
    borderStyle: "none none solid none",
    borderWidth: "1px",
    borderColor: "black"
  },

  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  imageUploadPreview: {
    width: 125,
    height: 125,
    cursor: "pointer"
  },
  customFont: {
    color: "#9bcec0"
  },
  resizableDiv: {
    minWidth: "349px",
    flexGrow: 1,
    position: "relative",
    display: "flex",
    overflow: "hidden"
  },
  // A 1px divider is a 1px target, which is what made these panels so awkward to
  // size. The grab area is 15px while the line stays 1px: the width is
  // transparent and the divider is painted by ::after at the very edge, so the
  // boundary looks exactly as it did. It can only reach inwards — the parent
  // clips its overflow — so the whole 15px sits on this panel's side.
  resizer: {
    width: "15px",
    height: "100%",
    position: "absolute",
    right: 0,
    zIndex: 5,
    cursor: "ew-resize",
    // The handle owns the gesture: without this a touch drag scrolls the page
    // instead, and the pointer capture below never gets to do its job.
    touchAction: "none",
    "&::after": {
      content: "''",
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1px",
      backgroundColor: "#000000",
      transition: "background-color 0.15s, width 0.15s"
    },
    // A 1px line needs the hover to be visible at all — hence the widening,
    // which the 3px version did not need.
    "&:hover::after": {
      width: "3px",
      backgroundColor: "#4eabb1"
    }
  }
}));
const iFrameId = "gamePreviewIframe";

export const applyPreview = ({ newGameConfig, selectedBase }) => {
  if (!selectedBase) {
    console.warn("Can't apply config when base is not selected. no op.");
    return;
  }
  const gamePreviewIframe = document.getElementById(iFrameId);
  if (!gamePreviewIframe) {
    return;
  }

  // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────────
  // Live config updates are handled via dedicated commands (playengine:set-*).
  // Sending playengine:load-snapshot here would race with engine startup and crash it.
  if (_.get(selectedBase, "playEngineInstance", false)) {
    return;
  }
  // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────────

  if (_.isFunction(gamePreviewIframe.contentWindow.applyGameConfig)) {
    console.dir(newGameConfig);
    try {
      // Clone so the playable cannot mutate dashboard version state
      // (e.g. baking localizationOverrides into components by reference).
      document.getElementById(iFrameId).contentWindow.applyGameConfig(_.cloneDeep(newGameConfig));
    } catch (err) {
      console.trace(err);
    }
  }
};

export const versionChanged = _.debounce(() => {
  const gamePreviewIframe = document.getElementById(iFrameId);

  if (!gamePreviewIframe) {
    return;
  }

  // Legacy-only hook. The playEngine preview is served from apiURI and can be
  // cross-origin, where merely reading a property of contentWindow throws.
  try {
    if (_.isFunction(gamePreviewIframe.contentWindow.changeVersion)) {
      gamePreviewIframe.contentWindow.changeVersion();
    }
  } catch (err) {
    console.trace(err);
  }
});

let timeoutID = null;
let pendingVersionRef = null;
let pendingPersist = null;
export default function home(props) {
  let [isTokenValidated, setIsTokenValidated] = useState(false);
  const [numberOfBases, setNumberOfBases] = useState(0);

  let [games, setGames] = useState([]);
  let [bases, setBases] = useState([]);
  let [baseIDProps, setBaseID] = useState([]);
  let [versions, setVersions] = useState([]);
  let [versionHierarchy, setVersionHierarchy] = useState([]);
  let [hierarchyEnabled, setHierarchyEnabled] = useState(false);
  let [treeIsSorted, setSortedTree] = useState("");
  let [sortAgain, setSortAgain] = useState(0);
  let [plans, setPlans] = useState([]);
  const [planIndexes, setPlanIndexes] = useState([]);
  const [galleryGames, setGalleryGames] = useState([]);

  let [media, setMedia] = useState([]);
  let [atlases, setAtlases] = useState([]);
  let [spines, setSpines] = useState([]);
  let [bitmapFonts, setBitmapFonts] = useState([]);
  let [sounds, setSounds] = useState([]);
  let [fonts, setFonts] = useState([]);
  let [videos, setVideos] = useState([]);
  let [glbs, setGlbs] = useState([]);

  let [areGamesLoaded, setAreGamesLoaded] = useState(false);
  let [areBasesLoaded, setAreBasesLoaded] = useState(false);
  let [areVersionsLoaded, setAreVersionsLoaded] = useState(false);
  let [areMediaLoaded, setAreMediaLoaded] = useState(false);
  let [areAtlasesLoaded, setAreAtlasesLoaded] = useState(false);
  let [areSpinesLoaded, setAreSpinesLoaded] = useState(false);
  let [areBitmapFontsLoaded, setAreBitmapFontsLoaded] = useState(false);
  let [areSoundsLoaded, setAreSoundsLoaded] = useState(false);
  let [areFontsLoaded, setAreFontsLoaded] = useState(false);
  let [areVideosLoaded, setAreVideosLoaded] = useState(false);
  let [areGlbsLoaded, setAreGlbsLoaded] = useState(false);
  let [arePlansLoaded, setArePlansLoaded] = useState(false);
  let [arePermissionsLoaded, setArePermissionsLoaded] = useState(false);
  let [defaultVersionUpdated, setDefaultVersionUpdated] = useState(false);
  let [isPreviewLoaded, setIsPreviewLoaded] = useState(false);
  let [searchBarValue, setSearchBarValue] = useState("");
  let [selectedGame, setSelectedGame] = useState();
  let [selectedBase, setSelectedBase] = useState();
  const [selectedModifiedBase, setSelectedModifiedBase] = useState();
  let [selectedVersion, setSelectedVersion] = useState();
  let [userCompany, setUserCompany] = useState();
  // The company an agent run is billed to — the user's OWN, even while it is
  // looking at another one. The same document as userCompany unless switched.
  let [agentCompany, setAgentCompany] = useState();
  let [userPermissions, setUserPermissions] = useState({});
  // Identity as the server reports it on every load — see validateToken.
  let [userRole, setUserRole] = useState("member");
  // Runtime bases screen for a non-superAdmin a superAdmin granted it to.
  let [canManageRuntimeBases, setCanManageRuntimeBases] = useState(false);
  // Companies screen (the base grant) for a non-superAdmin granted it.
  let [canGrantBasesToCompanies, setCanGrantBasesToCompanies] = useState(false);
  // Whether this user may change which games a pe3d base offers (roles.canGrantPe3dGames).
  let [canGrantPe3dGames, setCanGrantPe3dGames] = useState(false);
  let [isSwitchedCompany, setIsSwitchedCompany] = useState(false);
  let [switchTargets, setSwitchTargets] = useState([]);
  // Both admin tiers see the admin surfaces; only the superAdmin panel
  // distinguishes them further.
  const isAdmin = userRole === "superAdmin" || userRole === "companyAdmin";
  let [appEnv, setAppEnv] = useState("");
  let [defaultVersionID, setDefaultVersionID] = useState("");
  let [predefinedGameComponents, setPredefinedGameComponents] = useState([]);

  let [isAccountInfoVisible, setIsAccountInfoVisible] = useState(false);
  let [accountSettingsInitialPage, setAccountSettingsInitialPage] = useState(0);
  let [isInsertVersionDialogOpen, setIsInsertVersionDialogOpen] = useState(false);
  let [isRenameVersionDialogOpen, setIsRenameVersionDialogOpen] = useState(false);
  let [isRenameFolderDialogOpen, setIsRenameFolderDialogOpen] = useState(false);

  let [isFolderVersionDialogOpen, setIsFolderVersionDialogOpen] = useState(false);
  let [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  let [isDeleteAllDialogOpen, setIsDeleteAllDialogOpen] = useState(false);

  let [isDuplicateDialogOpen, setIsDuplicateDialogOpen] = useState(false);
  let [isFolderDialogOpen, setIsFolderDialogOpen] = useState(false);

  let [isDownloadDialogOpen, setIsDownloadDialogOpen] = useState(false);
  let [selectedFolderId, setSelectedFolderId] = useState(9999999);

  let [isUpdateTreeOpen, setUpdateTreeOpen] = useState("");
  let [isInsertNewVersion, setInsertNewVersion] = useState("");
  let [renameVersionName, setRenameVersionName] = useState("");
  let [newSetPortrait, setPortrait] = useState(true);
  let [versionsAreFetched, setVersionsAreFetched] = useState(false);
  // Native move/up listeners live for the duration of one drag. Read the
  // current editor mode without rebuilding the gesture as React re-renders.
  const isSnapshotEditorRef = useRef(false);
  const panelResizeCleanupRef = useRef(null);
  // let [newVersionTitle, setNewVersionTitle] = useState((selectedVersion) ? selectedVersion.title : "");

  let [renameFolderName, setRenameFolderName] = useState("");
  const [localizationLanguage, setLocalizationLanguage] = useState("");

  const [isDialogConfirmRefreshOpen, setIsDialogConfirmRefreshOpen] = useState(false);
  const [brokenAssets, setBrokenAssets] = useState([]);
  const isBrokenPopupOpenRef = useRef(false);
  const unrepairableAssetKeysRef = useRef(new Set());
  const [pendingCascadeInfo, setPendingCascadeInfo] = useState(null);
  const [isDialogCircularProgressOpen, setIsDialogCircularProgressOpen] = useState(false);
  const [isDialogViewOnlyModeOpen, setIsDialogViewOnlyModeOpen] = useState(false);
  const [isDialogFetchUpdatesOnVersionOpen, setIsDialogFetchUpdatesOnVersionOpen] = useState(false);
  const [lastUpdatingUser, setLastUpdatingUser] = useState();
  const [isDownloadingPlayable, setIsDownloadingPlayable] = useState(false);

  const [totalSizeValue, setTotalSize] = useState(0);
  let [refresh, doRefresh] = useState(0);

  let [isRecorderEnabled, setRecorderEnabled] = useState(false);
  let [maxInnerHeight, setMaxInnerHeight] = useState(null);
  let [menuLayout, setMenuLayout] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [originalTreeData, setOTreeData] = useState([]);
  const [prevSelectedRecorderSettings, setPrevSelectedRecorderSettings] = useState(null);
  const [prevButton, setPrevButton] = useState(null);
  const [heightInPx, setHeightInPx] = useState(null);
  const [defaultVersion, setDefaultVersion] = useState("");

  const column1TopRef = useRef(null);

  let dummyTree = [];

  const undoCtx = useContext(UndoContext);

  // snapshot editor state. Inert (fetches nothing) on every other
  // base, so it can be called unconditionally here alongside the other hooks.
  const snapshotEditor = useSnapshotEditor({
    baseID: isSnapshotEditorBase(selectedBase) ? _.get(selectedBase, "_id") : null,
    flow: snapshotFlowOf(selectedBase),
    taskDelivery: hasTaskDelivery(selectedBase),
    exportAsVersion: hasExportAsVersion(selectedBase),
    createSnackbar,
  });

  // pe3d (PlayEngine3D) state. Inert on every other base, like the snapshot editor's.
  const pe3dEditor = usePe3dEditor({
    baseID: isPe3dBase(selectedBase) ? _.get(selectedBase, "_id") : null,
    createSnackbar,
  });

  // The content permissions, defaulted to false so a component asking
  // `=== false` gets a real answer rather than undefined. Permissions the user
  // does hold are switched on from the session response; ones outside this list
  // (transferVersion, bulkUpdateDatabase) are tested with `=== true` and need no
  // default. The migration writes the old names alongside these during the
  // deploy window; nothing here reads them any more.
  const [userPermissionsInitial, setUserPermissionsInitial] = useState({
    "viewContent": false,
    "editContent": false,
    "manageAssets": false,
    "createVersion": false,
    "deleteContent": false,
    "exportPlayable": false
  });

  const { enqueueSnackbar } = useSnackbar();
  const prevVersion = usePrevious(selectedVersion);

  useEffect(() => {
    const handler = () => {
      setAccountSettingsInitialPage(4);
      setIsAccountInfoVisible(true);
    };
    window.addEventListener("openToolSettings", handler);
    return () => window.removeEventListener("openToolSettings", handler);
  }, []);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("pendingCascade");
      localStorage.removeItem("pendingCascade");
      if (!raw) return;
      const info = JSON.parse(raw);
      if (info && info.assetType) setPendingCascadeInfo(info);
    } catch (e) {
      try { localStorage.removeItem("pendingCascade"); } catch (e2) { /* ignore */ }
    }
  }, []);

  const classes = useStyles();

  let messageListener = useRef(null);
  window.removeEventListener("message", messageListener.current);
  messageListener.current = window.addEventListener("message", (message) => {
    if (!message) return;
    if (message.data.action === "activeTabPermitted") {
      if (!isRecorderEnabled) {
        setRecorderEnabled(true);
      }
      setMaxInnerHeight(message.data.maxInnerHeight);
    }
  });

  function validateToken() {
    return new Promise((resolve, reject) => {
      const requestURI = getServerUri("authentication/validateAccessToken");
      const requestInit = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      };
      fetch(requestURI, requestInit)
        .then(async (response) => {
          if (response.status === 200) {
            setIsTokenValidated(true);

            let session = null;
            try {
              session = await response.json();
            } catch (e) {
              session = null;
            }
            setAppEnv(session && session.env ? session.env : "");

            // Identity comes from this response, not from localStorage. It used
            // to be frozen at login, so granting or renaming a permission left
            // every open session acting on stale rights until the user signed
            // out and back in. localStorage is now just a cache the rest of the
            // app still reads, so it is refreshed from the live answer here.
            const sessionUser = (session && session.user) || null;
            if (sessionUser) {
              localStorage.setItem("user.id", String(sessionUser.id));
              localStorage.setItem("user.username", String(sessionUser.username));
              localStorage.setItem("user.companyID", String(sessionUser.companyID));
              localStorage.setItem("user.homeCompanyID", String(sessionUser.homeCompanyID));
              localStorage.setItem("user.role", String(sessionUser.role));
              localStorage.setItem("user.hasInternalTools", String(sessionUser.hasInternalTools === true));
              // Which editor panels this user may see; read back by
              // containerGameConfig when it builds its tab rail.
              cacheTabRestrictions(session);
              localStorage.setItem("user.permissions", (sessionUser.permissions || []).join(","));
              if (sessionUser.companyName) {
                localStorage.setItem("user.companyName", String(sessionUser.companyName));
              }
              setUserRole(sessionUser.role);
              setCanManageRuntimeBases(sessionUser.canManageRuntimeBases === true);
              setCanGrantBasesToCompanies(sessionUser.canGrantBasesToCompanies === true);
              setCanGrantPe3dGames(sessionUser.canGrantPe3dGames === true);
              setIsSwitchedCompany(Boolean(sessionUser.isSwitched));
              // Active-time beats for the usage analytics; idempotent, starts once per tab.
              startUsageHeartbeat();
            }
            setSwitchTargets((session && session.switchTargets) || []);
            // Cached for the snapshot editor's export dialog, which is mounted
            // far from here and only needs the list at the moment it opens.
            localStorage.setItem("user.exportTargets", JSON.stringify((session && session.exportTargets) || []));

            const permissionsArray = sessionUser
              ? sessionUser.permissions || []
              : (localStorage.getItem("user.permissions") || "").split(",").filter(Boolean);

            let newUserPermissionsInitial = _.cloneDeep(userPermissionsInitial);
            if (permissionsArray.length > 0) {
              for (const item of permissionsArray) {
                newUserPermissionsInitial[item] = true;
              }
            } else {
              newUserPermissionsInitial = null;
            }
            setUserPermissionsInitial(newUserPermissionsInitial);
            setUserPermissions(newUserPermissionsInitial);
            resolve(true);
          } else {
            reject({ message: "token is invalid" });
          }
        })
        .catch((err) => reject);
    });
  }

  function fetchGames() {
    console.info("fetching games");
    return new Promise((resolve, reject) => {
      fetch(getServerUri("game/find"), {
        method: "POST",
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken")
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedGames) => {
                // Stays empty when the company reaches no games at all.
                let fetchedGamesDescending = [];
                let newfetchedGamesDescending = [];
                if (Array.isArray(fetchedGames) && fetchedGames.length > 0) {
                  for (var i = 0; i < fetchedGames.length; i++) {
                    if (
                      fetchedGames[i]._id === "62b9a830cc0ad8e0a9eaa81c" ||
                      fetchedGames[i]._id === "62a09e2041f6066717fff686" ||
                      fetchedGames[i]._id === "66fea2d30255a9f80892a1ec" ||
                      fetchedGames[i]._id === "6855138e934c54b913ec620e"
                    ) {
                      newfetchedGamesDescending.push(fetchedGames[i]);
                      fetchedGames.splice(i, 1);
                      i--;
                    }
                  }
                  fetchedGamesDescending = fetchedGames.reverse();

                  if (newfetchedGamesDescending.length > 0) {
                    fetchedGamesDescending = newfetchedGamesDescending.concat(fetchedGamesDescending);
                  }
                }
                let countNumberOfBases = 0;
                let waiting = fetchedGamesDescending.length;
                fetchedGamesDescending.forEach((game) => {
                  doAsynchronousFunction(game, finish);
                });
                // A company whose base grant is still empty arrives here with
                // no games: nothing calls finish(), so the load is completed
                // directly or the page waits on games forever.
                if (waiting === 0) {
                  completeGamesLoad();
                }
                function finish() {
                  waiting -= 1;
                  if (waiting === 0) {
                    completeGamesLoad();
                  }
                }
                function completeGamesLoad() {
                  setNumberOfBases(countNumberOfBases);
                  const notGalleryGames = fetchedGamesDescending.filter(
                    (game) => !_.has(game, "isInPlayableGallery") || game.isInPlayableGallery === false
                  );
                  const galleryGames = fetchedGamesDescending.filter(
                    (game) => _.has(game, "isInPlayableGallery") && game.isInPlayableGallery === true
                  );
                  setGames(notGalleryGames);
                  setGalleryGames(galleryGames);
                  setAreGamesLoaded(true);
                  if (
                    !_.isNil(localStorage.getItem("selectedGameID")) &&
                    !_.isNil(
                      notGalleryGames.filter(
                        (game) => _.get(game, "_id") === localStorage.getItem("selectedGameID")
                      )[0]
                    )
                  ) {
                    const userSelectedGame = notGalleryGames.filter(
                      (game) => _.get(game, "_id") === localStorage.getItem("selectedGameID")
                    )[0];
                    setSelectedGame(userSelectedGame);
                  } else {
                    if (
                      !_.isNil(localStorage.getItem("selectedGameID")) &&
                      !_.isNil(
                        galleryGames.filter(
                          (game) => _.get(game, "_id") === localStorage.getItem("selectedGameID")
                        )[0]
                      )
                    ) {
                      const userSelectedGame = galleryGames.filter(
                        (game) => _.get(game, "_id") === localStorage.getItem("selectedGameID")
                      )[0];
                      setSelectedGame(userSelectedGame);
                    } else if (!selectedGame && Array.isArray(notGalleryGames) && notGalleryGames.length > 0) {
                      setSelectedGame(notGalleryGames[0]);
                      localStorage.setItem("selectedGameID", _.get(notGalleryGames[0], "_id"));
                    } else if (!selectedGame && Array.isArray(galleryGames) && galleryGames.length > 0) {
                      setSelectedGame(galleryGames[0]);
                      localStorage.setItem("selectedGameID", _.get(galleryGames[0], "_id"));
                    }
                  }
                  resolve(notGalleryGames.concat(galleryGames));
                }
                function doAsynchronousFunction(game, callback) {
                  getNumberOfBases(game._id).then((res) => {
                    countNumberOfBases += res;
                    callback();
                  });
                }
              })
              .catch((err) => reject);
          } else {
            response
              .text()
              .then((err) => reject)
              .catch((err) => reject);
          }
        })
        .catch((err) => reject);
    });
  }


  function getNumberOfBases(gameID) {
    return new Promise((resolve, reject) => {
      fetch(getServerUri("base/find"), {
        method: "POST",
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          gameID: gameID
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedBases) => {
                resolve(_.size(fetchedBases));
              })
              .catch((err) => reject);
          } else {
            response
              .text()
              .then((err) => reject)
              .catch((err) => reject);
          }
        })
        .catch((err) => reject);
    });
  }

  function fetchBases(gameID) {
    console.info("fetching bases");
    return new Promise((resolve, reject) => {
      fetch(getServerUri("base/find"), {
        method: "POST",
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          gameID: gameID
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedBases) => {
                setBases(fetchedBases);
                setAreBasesLoaded(true);
                if (!_.isNil(localStorage.getItem("selectedBaseID"))) {
                  const userSelectedBase = fetchedBases.filter(
                    (base) => _.get(base, "_id") === localStorage.getItem("selectedBaseID")
                  )[0];
                  setVersionHierarchy(dummyTree);

                  // The stored base can belong to another game (or be deleted);
                  // fall back to the first base so a base is always selected.
                  if (!_.isNil(userSelectedBase)) {
                    setSelectedBase(userSelectedBase);
                  } else if (_.size(fetchedBases) > 0) {
                    setSelectedBase(fetchedBases[0]);
                    localStorage.setItem("selectedBaseID", _.get(fetchedBases[0], "_id"));
                  }
                  setSelectedFolderId(9999999);
                } else {
                  if (_.size(fetchedBases) > 0 && !selectedBase) {
                    setVersionHierarchy(dummyTree);
                    setSelectedBase(fetchedBases[0]);
                    setSelectedFolderId(9999999);

                    localStorage.setItem("selectedBaseID", _.get(fetchedBases[0], "_id"));
                  }
                }
                resolve(fetchedBases);
              })
              .catch((err) => reject);
          } else {
            response
              .text()
              .then((err) => reject)
              .catch((err) => reject);
          }
        })
        .catch((err) => reject);
    });
  }

  function fetchPredefinedGameComponents() {
    return new Promise((resolve, reject) => {
      fetch(getServerUri("base/predefinedGameComponents"), {
        method: "POST",
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken")
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((data) => {
              setPredefinedGameComponents(data);
              resolve(data);
            });
          } else {
            response
              .text()
              .then(() => reject)
              .catch(() => reject);
          }
        })
        .catch(() => reject);
    });
  }

  function fetchVersions(baseID, companyID, baseOverride) {
    console.info("fetching versions");

    // ── PLAYENGINE BRANCH ────────────────────────────────────────────────────
    // Look up the base from the populated `bases` array by baseID so this works
    // even when called right after setSelectedBase() before React re-renders.
    const baseForCheck =
      baseOverride ||
      bases.find((b) => String(b._id) === String(baseID)) ||
      selectedBase;
    if (_.get(baseForCheck, "playEngineInstance", false)) {
      return new Promise((resolve, reject) => {
        const companyId = companyID || localStorage.getItem("user.companyID");
        const resolvedBaseID = baseID ? baseID : String(selectedBase._id);

        perfAsync("refetch:versionPlayEngine/find (network)", () => fetch(getServerUri("versionPlayEngine/find"), {
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            accessToken: localStorage.getItem("session.accessToken"),
            baseID: resolvedBaseID,
          }),
        }))
          .then((response) => {
            if (response.status === 200) {
              perfAsync("refetch:parse all versions JSON", () => response.json()).then(async (versionRecords) => {
                setAreVersionsLoaded(true);
                if (!selectedVersion && _.size(versionRecords) > 0) {
                  const savedID = localStorage.getItem("selectedVersionID");
                  const targetVersion =
                    savedID && versionRecords.some((v) => _.get(v, "_id") === savedID)
                      ? versionRecords.find((v) => _.get(v, "_id") === savedID)
                      : versionRecords[0];
                  setSelectedVersion(targetVersion);
                  localStorage.setItem("selectedVersionID", _.get(targetVersion, "_id", ""));
                }

                const { tree, hierarchyEnabled: hierEnabled } = await perfAsync(
                  "refetch:resolvePlayEngineTree (extra requests)",
                  () => resolvePlayEngineTree(resolvedBaseID, companyId, versionRecords)
                );
                setHierarchyEnabled(hierEnabled);
                setVersionHierarchy(tree);
                setVersions(versionRecords);
                setSelectedVersion((prev) => {
                  if (!prev) return prev;
                  const refreshed = versionRecords.find(
                    (v) => String(v._id) === String(prev._id)
                  );
                  return refreshed || prev;
                });
                resolve(versionRecords);
                setVersionsAreFetched(true);
              });
            } else {
              response
                .text()
                .then((err) => reject(err))
                .catch(() => reject);
            }
          })
          .catch(() => reject);
      });
    }
    // ── END PLAYENGINE BRANCH ────────────────────────────────────────────────

    var versionHierarchy = new Promise(() => {
      fetch(getServerUri("version/getHierarchy"), {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          baseID: baseID ? baseID : "6140893d93ddb73076a1554e",
          companyID: companyID ? companyID : "5fcde275da672a1d3a53cf0b"
        })
      }).then((response) => {
        if (response.status === 200) {
          response.json().then((json) => {
            setVersionHierarchy(json.versionHierarchy);
            setUpdateTreeOpen(json.versionHierarchy);
            setBaseID(baseID);
          });
        }
      });
    });

    return new Promise((resolve, reject) => {
      fetch(getServerUri("version/find"), {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          baseID: baseID ? baseID : String(selectedBase._id)
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((versionRecords) => {
              setAreVersionsLoaded(true);
              if (!selectedVersion && _.size(versionRecords) > 0) {
                if (!versionRecords[0].hasOwnProperty("gameConfig")) {
                  throw {
                    message: "version record doesn't contain gameConfig",
                    versionRecord: versionRecords[0]
                  };
                }
                if (
                  !_.isNil(localStorage.getItem("selectedVersionID")) &&
                  versionRecords.some((version) => _.get(version, "_id") === localStorage.getItem("selectedVersionID"))
                ) {
                  const userSelectedVersion = versionRecords.filter(
                    (version) => _.get(version, "_id") === localStorage.getItem("selectedVersionID")
                  )[0];
                  const currentTime = new Date().getTime();
                  const dateUpdatedTime = new Date(_.get(userSelectedVersion, "dateUpdated", currentTime)).getTime();
                  if (dateUpdatedTime < currentTime - 1000 * 60 * 60) {
                    // 1 hour
                    //_.set(userSelectedVersion, 'isBeingUpdated', false);
                  }
                  setSelectedVersion(userSelectedVersion);
                  for (let i = 0; i < versionRecords.length; i++)
                    if (versionRecords[i]._id === userSelectedVersion._id) {
                      versionRecords[i] = _.cloneDeep(userSelectedVersion);
                    }
                  applyPreview({
                    newGameConfig: userSelectedVersion.gameConfig,
                    selectedBase: _.has(selectedBase, "predefinedGameComponents")
                      ? _.isNil(selectedModifiedBase)
                        ? processPredefinedGameComponentsToBase(selectedBase)
                        : selectedModifiedBase
                      : selectedBase
                  });
                } else {
                  const currentTime = new Date().getTime();
                  const dateUpdatedTime = new Date(_.get(versionRecords[0], "dateUpdated", currentTime)).getTime();
                  if (dateUpdatedTime < currentTime - 1000 * 60 * 60) {
                    // 1 hour @TODO
                  }
                  setSelectedVersion(versionRecords[0]);
                  localStorage.setItem("selectedVersionID", _.get(versionRecords[0], "_id"));
                  applyPreview({
                    newGameConfig: versionRecords[0].gameConfig,
                    selectedBase: _.has(selectedBase, "predefinedGameComponents")
                      ? _.isNil(selectedModifiedBase)
                        ? processPredefinedGameComponentsToBase(selectedBase)
                        : selectedModifiedBase
                      : selectedBase
                  });
                }
              }
              setVersions(versionRecords);
              resolve(versionRecords);
              setVersionsAreFetched(true);
            });
          } else {
            response
              .text()
              .then((err) => reject)
              .catch((err) => reject);
          }
        })
        .catch((err) => reject);
    });
  }

  function fetchImages() {
    console.info("Fetching Images");
    return new Promise((resolve, reject) => {
      console.info("find media uri: ", getServerUri("media/find"));
      fetch(getServerUri("media/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedImages) => {
                setMedia(fetchedImages);
                setAreMediaLoaded(true);
                resolve(fetchedImages);
              })
              .catch(reject);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchAtlases() {
    console.info("Fetching Atlases");
    return new Promise((resolve, reject) => {
      console.info("find atlas uri: ", getServerUri("atlas/find"));
      fetch(getServerUri("atlas/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedAtlases) => {
                setAtlases(fetchedAtlases);
                setAreAtlasesLoaded(true);
                resolve(fetchedAtlases);
              })
              .catch(reject);
          } else if (response.status === 401) {
            createSnackbar("You are not authorized to view, contact your administrator.", "warning");
            response
              .text()
              .then((textResponse) => {
                console.log({ message: "error viewing", textResponse });
              })
              .catch(console.error);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchSpines() {
    console.info("Fetching Spines");
    return new Promise((resolve, reject) => {
      console.info("find spine uri: ", getServerUri("spine/find"));
      fetch(getServerUri("spine/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedSpines) => {
                setSpines(fetchedSpines);
                setAreSpinesLoaded(true);
                resolve(fetchedSpines);
              })
              .catch(reject);
          } else if (response.status === 401) {
            createSnackbar("You are not authorized to view, contact your administrator.", "warning");
            response
              .text()
              .then((textResponse) => {
                console.log({ message: "error viewing", textResponse });
              })
              .catch(console.error);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchBitmapFonts() {
    console.info("Fetching Bitmap Fonts");
    return new Promise((resolve, reject) => {
      fetch(getServerUri("bitmapFont/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedBitmapFonts) => {
                setBitmapFonts(fetchedBitmapFonts);
                setAreBitmapFontsLoaded(true);
                resolve(fetchedBitmapFonts);
              })
              .catch(reject);
          } else if (response.status === 401) {
            createSnackbar("You are not authorized to view, contact your administrator.", "warning");
            response
              .text()
              .then((textResponse) => {
                console.log({ message: "error viewing", textResponse });
              })
              .catch(console.error);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchSounds() {
    console.info("Fetching Sounds");
    return new Promise((resolve, reject) => {
      console.info("find sound uri: ", getServerUri("sound/find"));
      fetch(getServerUri("sound/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedSounds) => {
                setSounds(fetchedSounds);
                setAreSoundsLoaded(true);
                resolve(fetchedSounds);
              })
              .catch(reject);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchFonts() {
    console.info("Fetching Fonts");
    return new Promise((resolve, reject) => {
      console.info("find font uri: ", getServerUri("font/find"));
      fetch(getServerUri("font/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedFonts) => {
                setFonts(fetchedFonts);
                setAreFontsLoaded(true);
                resolve(fetchedFonts);
              })
              .catch(reject);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchVideos() {
    console.info("Fetching Videos");
    return new Promise((resolve, reject) => {
      console.info("find video uri: ", getServerUri("video/find"));
      fetch(getServerUri("video/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedVideos) => {
                setVideos(fetchedVideos);
                setAreVideosLoaded(true);
                resolve(fetchedVideos);
              })
              .catch(reject);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchGlbs() {
    console.info("Fetching Glbs");
    return new Promise((resolve, reject) => {
      console.info("find glb uri: ", getServerUri("glb/find"));
      fetch(getServerUri("glb/find"), {
        method: "POST",
        body: new URLSearchParams({ accessToken: localStorage.getItem("session.accessToken") })
      })
        .then((response) => {
          if (response.status === 200) {
            response
              .json()
              .then((fetchedGlbs) => {
                setGlbs(fetchedGlbs);
                setAreGlbsLoaded(true);
                resolve(fetchedGlbs);
              })
              .catch(reject);
          } else {
            response.text().then(reject).catch(reject);
          }
        })
        .catch(reject);
    });
  }

  function fetchPlans() {
    console.info("fetching plans");
    return new Promise((resolve, reject) => {
      fetch(getServerUri("plan/find"), {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken")
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((planRecords) => {
              setPlans(planRecords);

              const initialPlanIndexes = [];
              for (let i = 0; i < planRecords.length; i++) {
                initialPlanIndexes[_.get(planRecords[i], "type", "")] = i;
              }
              setPlanIndexes(initialPlanIndexes);
              setArePlansLoaded(true);

              const planRecordsAndIndexes = {};
              _.set(planRecordsAndIndexes, "planRecords", planRecords);
              _.set(planRecordsAndIndexes, "planIndexes", initialPlanIndexes);
              resolve(planRecordsAndIndexes);
            });
          } else {
            response
              .text()
              .then((err) => reject)
              .catch((err) => reject);
            console.log("errror in fetching plans");
          }
        })
        .catch((err) => reject);
    });
  }

  /** One company document by id, or null if it cannot be read. */
  function fetchCompanyById(companyID) {
    if (!companyID) {
      return Promise.resolve(null);
    }
    return fetch(getServerUri("company/findOne"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        companyID: String(companyID)
      })
    }).then((response) => (response.status === 200 ? response.json() : null));
  }

  /**
   * The company on screen, and the one the agent bills.
   *
   * They are the same document for everybody who has not switched. A switched
   * user works inside another company's content but spends its own AI credits
   * (see server controller/agent/agentAccess.js), so that second document has to
   * be fetched separately — the one on screen belongs to somebody else.
   */
  function fetchCompanyPermissions() {
    const activeID = localStorage.getItem("user.companyID");
    const homeID = localStorage.getItem("user.homeCompanyID") || activeID;

    return fetchCompanyById(activeID)
      .then((company) => {
        setUserCompany(company);
        if (!company || String(homeID) === String(activeID)) {
          setAgentCompany(company || null);
          return true;
        }
        return fetchCompanyById(homeID).then((home) => {
          setAgentCompany(home || null);
          return true;
        });
      })
      .catch((err) => {
        // Always resolve. The bootstrap chain waits on this, and a promise that
        // neither resolves nor rejects is a spinner that never stops — which is
        // what the old version did on any non-200.
        console.error("[home] Could not load the company:", err && err.message);
        return true;
      });
  }

  /**
   * Starts the next subscription period for the company on screen, and for the
   * user's own company when switched (its agent credits are what get spent).
   * The server computes the period, so this works for members and switched users
   * alike. Always resolves: a failure here must not stall the bootstrap chain.
   */
  function fetchAndUpdateCompanySubscription() {
    const activeID = localStorage.getItem("user.companyID");
    const homeID = localStorage.getItem("user.homeCompanyID") || activeID;
    const companyIDs = _.uniq([activeID, homeID].filter(Boolean).map(String));

    return Promise.all(
      companyIDs.map((companyID) =>
        rolloverCompanySubscription(companyID).catch((err) => {
          console.error("[home] Subscription rollover failed:", err && err.message);
          return null;
        })
      )
    ).then(([activeCompany]) => activeCompany);
  }

  //close autoplay on page close event for close autoplay
  function closeAutoplay(version) {
    let isAutoplay;
    if (!_.isNil(version)) {
      isAutoplay = _.get(version, "gameConfig.components.autoplay1.startAutoplay", null);
      if (!_.isNil(isAutoplay) && isAutoplay) {
        setSelectedVersionPathValueWithVersion(
          {
            path: "gameConfig.components.autoplay1.startAutoplay",
            value: false
          },
          version
        );
      }
    }
    return isAutoplay;
  }

  function getPlanIndex(planType) {
    try {
      return planIndexes[planType];
    } catch (err) {
      console.log(err);
    }
  }
  //trigger the function when refresh or close the page
  window.onunload = window.onbeforeunload = function () {
    closeAutoplay(selectedVersion);
    // Best effort: a request started here often does not finish. The reliable
    // one is the visibilitychange flush below, which fires when the tab is
    // hidden — including on the way to being closed.
    persistQueue.flushAll();
  };

  // Hiding the tab is the last moment a save is certain to go out, so anything
  // still sitting in the debounce goes now.
  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === "hidden") persistQueue.flushAll();
    };
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, []);

  // A route/base change can remove a splitter while it owns the global text
  // selection lock. Finish any live gesture before this page unmounts.
  useEffect(() => () => {
    panelResizeCleanupRef.current?.();
  }, []);

  const circularProgressDiv = function (thicknessVal) {
    return (
      <div id={"circularProgressDiv"} className={classes.circularProgressDiv}>
        <CircularProgress thickness={thicknessVal ? thicknessVal : 3.6} variant={"indeterminate"}></CircularProgress>
      </div>
    );
  };

  /**
   * The pair a handle resizes: the box it sits in, and that box's next sibling.
   *
   * ONE definition on purpose. This DOM walk is the fragile part of the
   * splitter — put any element between those two and the handle silently sizes
   * the wrong thing, no error at all. A wrapper with `display: contents` did
   * exactly that once: invisible to layout, but `nextElementSibling` found it
   * anyway, so the width went to a box that had none and the left pane grew.
   */
  function resizerPair(resizer) {
    const first = resizer && resizer.parentElement;
    const second = first && first.nextElementSibling;
    return first && second ? { first, second } : null;
  }

  /** Double-click steps, as a share of the two panes a handle divides. */
  const SNAP_FRACTIONS = [0.3, 0.5, 0.7];
  /** Past this share, the preview gives up the rest of the row. */
  const COLLAPSE_AT = 0.7;
  /**
   * What the collapsed preview keeps — not zero.
   *
   * The handle lives INSIDE the preview at `right: 0`, and the preview clips
   * (`overflow: hidden`). Collapse it to nothing and the handle is clipped with
   * it: the panel could be opened and never closed again. This is a hair over
   * the handle's own 15px, so the grab strip survives as the seam you drag back.
   */
  const PREVIEW_COLLAPSED = 16;

  /** The handle before the config panel — the last one in document order. */
  function rightResizer() {
    const all = document.querySelectorAll(`.${classes.resizer}`);
    return all.length ? all[all.length - 1] : null;
  }

  // React owns the pointerdown binding. The former imperative binding ran from
  // render and could attach the same listener twice after a base change. The
  // first copy saved `userSelect === ""`; the second saved the `"none"` written
  // by the first, then restored that stale lock on pointerup.
  function startPanelResize(e) {
    if (e.button !== 0) return;
    e.preventDefault();

    panelResizeCleanupRef.current?.();

    const resizer = e.currentTarget;
    const pointerId = e.pointerId;
    const pair = resizerPair(resizer);
    if (!pair) return;
    const { first: div1, second: div2 } = pair;
    const originalWidth1 = div1.offsetWidth;
    const originalWidth2 = div2.offsetWidth;
    const originalMouseX = e.pageX;
    // A previous duplicate listener may already have leaked `none` into the
    // inline style (notably across hot reload). This gesture owns the lock now,
    // so completing it should always recover normal selection.
    const originalUserSelect = document.body.style.userSelect === "none"
      ? ""
      : document.body.style.userSelect;
    let stopped = false;

    document.body.style.userSelect = "none";

    try {
      resizer.setPointerCapture(pointerId);
    } catch (_err) {
      // Capture refused: window listeners remain the fallback.
    }

    function resize(moveEvent) {
      const dx = moveEvent.pageX - originalMouseX;
      const newWidth1 = originalWidth1 + dx;
      const newWidth2 = originalWidth2 - dx;
      const total = originalWidth1 + originalWidth2;

      if (
        isSnapshotEditorRef.current &&
        resizer === rightResizer() &&
        newWidth2 > total * COLLAPSE_AT
      ) {
        div1.style.width = `${PREVIEW_COLLAPSED}px`;
        div2.style.width = `${total - PREVIEW_COLLAPSED}px`;
        return;
      }

      if (newWidth1 > 50 && newWidth2 > 50) {
        div1.style.width = `${newWidth1}px`;
        div2.style.width = `${newWidth2}px`;
      }
    }

    function stopResize() {
      if (stopped) return;
      stopped = true;
      window.removeEventListener("pointermove", resize);
      window.removeEventListener("pointerup", stopResize);
      window.removeEventListener("pointercancel", stopResize);
      window.removeEventListener("blur", stopResize);
      document.removeEventListener("visibilitychange", stopResizeWhenHidden);
      resizer.removeEventListener("lostpointercapture", stopResize);
      document.body.style.userSelect = originalUserSelect;
      panelResizeCleanupRef.current = null;
      try {
        if (resizer.hasPointerCapture(pointerId)) resizer.releasePointerCapture(pointerId);
      } catch (_err) {
        // Already released, or never captured.
      }
    }

    function stopResizeWhenHidden() {
      if (document.hidden) stopResize();
    }

    window.addEventListener("pointermove", resize);
    window.addEventListener("pointerup", stopResize);
    window.addEventListener("pointercancel", stopResize);
    window.addEventListener("blur", stopResize);
    document.addEventListener("visibilitychange", stopResizeWhenHidden);
    resizer.addEventListener("lostpointercapture", stopResize);
    panelResizeCleanupRef.current = stopResize;
  }

  function stepPanelWidth(e) {
    const pair = resizerPair(e.currentTarget);
    if (!pair) return;
    const total = pair.first.offsetWidth + pair.second.offsetWidth;
    if (total < 200) return;

    const current = pair.second.offsetWidth / total;
    const next = SNAP_FRACTIONS.find((fraction) => fraction > current + 0.02) || SNAP_FRACTIONS[0];
    const width = Math.round(total * next);
    pair.first.style.width = `${total - width}px`;
    pair.second.style.width = `${width}px`;
  }

  function processPredefinedGameComponentsToBase(selectedBase) {
    if (!_.isNil(selectedModifiedBase)) return;
    const base = selectedBase;
    const modifiedBase = _.cloneDeep(base);

    // console.log("modified base", base);
    const rawBasePredefinedGameComponents = _.get(base, "predefinedGameComponents", []);
    const currentBasePredefinedGameComponents = [];
    rawBasePredefinedGameComponents.forEach((rawComponent) => {
      if (_.isNil(rawComponent.levelSettings)) {
        currentBasePredefinedGameComponents.push(rawComponent);
        return;
      }
      // Shared container node: keeps only the general (non-level) settings such as assets.
      const containerComponent = _.omit(_.cloneDeep(rawComponent), ["levelSettings", "pathPrefix", "levelIndex"]);
      containerComponent.isLevelContainer = true;
      currentBasePredefinedGameComponents.push(containerComponent);
      // Per-level child nodes nested under the container: keep only the level-specific settings.
      Object.keys(rawComponent.levelSettings).forEach((levelKey, levelOrder) => {
        const levelSetting = rawComponent.levelSettings[levelKey] || {};
        const childComponent = _.omit(_.cloneDeep(rawComponent), ["levelSettings", "caption"]);
        childComponent.parentKey = rawComponent.key;
        childComponent.parentId = rawComponent.id;
        childComponent.levelIndex = _.get(levelSetting, "levelIndex", levelOrder);
        childComponent.pathPrefix = _.get(levelSetting, "pathPrefix", `levelConfigs.${levelKey}`);
        childComponent.caption = _.get(
          levelSetting,
          "caption",
          _.upperFirst(levelKey.replace(/([a-zA-Z])(\d)/g, "$1 $2"))
        );
        childComponent.isLevelChild = true;
        currentBasePredefinedGameComponents.push(childComponent);
      });
    });

    // A setting is "shared" (general, not level-specific) when pathPrefix does not apply to it:
    // asset paths and settings flagged with skipPathPrefix.
    const isSharedLevelSetting = (setting) =>
      setting.path.startsWith("selectedImages.")
      || setting.path.startsWith("selectedAtlases.")
      || setting.path.startsWith("selectedSpines.")
      || setting.skipPathPrefix === true;

    // console.log("enters here", { base, predefinedGameComponents, currentBasePredefinedGameComponents });
    const currentBasePredefinedGameComponentsCount = currentBasePredefinedGameComponents.length;
    if (currentBasePredefinedGameComponentsCount < 1) return base;
    let anyChange = false;
    for (let i = currentBasePredefinedGameComponentsCount - 1; i >= 0; i--) {
      const currentBasePredefinedGameComponent = currentBasePredefinedGameComponents[i];
      const key = currentBasePredefinedGameComponent.key;
      const id = currentBasePredefinedGameComponent.id;
      const currentMapIndex = _.get(currentBasePredefinedGameComponent, "levelIndex", null);
      const isIdExist =
        _.findIndex(modifiedBase.versionSettings.components, (e) => {
          if (currentMapIndex !== null) {
            return e.id === id && e.levelIndex === currentMapIndex;
          }
          return e.id === id && _.isNil(e.levelIndex);
        }) > -1;
      if (isIdExist) continue;
      const predefinedGameComponentDetail = _.find(predefinedGameComponents, (e) => {
        return e.key === key;
      });
      if (_.isNil(predefinedGameComponentDetail)) continue;
      const groups = _.get(predefinedGameComponentDetail, "groups", []);
      anyChange = true;
      const caption =
        predefinedGameComponentDetail?.caption ??
        currentBasePredefinedGameComponent?.caption ??
        predefinedGameComponentDetail?.versionSettings?.components?.[0]?.caption ??
        predefinedGameComponentDetail?.localizationSettings?.components?.[0]?.caption ??
        "Caption";

      const section = _.get(currentBasePredefinedGameComponent, "section", "Default");
      const subSection = _.get(currentBasePredefinedGameComponent, "subSection", null);
      const parentKey =
        _.get(currentBasePredefinedGameComponent, "parentKey", null)
        ?? _.get(predefinedGameComponentDetail, "parentKey", null);
      const parentId =
        _.get(currentBasePredefinedGameComponent, "parentId", null)
        ?? _.get(predefinedGameComponentDetail, "parentId", null);
      // console.log("enters here", currentBasePredefinedGameComponents[i], {
      //   predefinedGameComponentDetail,
      //   id,
      // });
      // VERSION SETTINGS
      if (_.has(predefinedGameComponentDetail, "versionSettings")) {
        const versionSettingsComponentsClone = _.cloneDeep(predefinedGameComponentDetail.versionSettings.components);
        const ignoredVersionSettingsPath = _.get(
          currentBasePredefinedGameComponent,
          "ignoredPaths.versionSettings",
          []
        );
        versionSettingsComponentsClone.forEach((component) => {
          component.settings = component.settings.filter((setting) => {
            return !ignoredVersionSettingsPath.includes(setting.path);
          });
        });
        const versionSettingsComponent = versionSettingsComponentsClone[0];
        // console.log("enters here", { versionSettingsComponentsClone, id });
        versionSettingsComponent.id = id;
        versionSettingsComponent.key = key;
        versionSettingsComponent.caption = caption;
        versionSettingsComponent.section = section;
        if (!_.isNil(subSection)) {
          versionSettingsComponent.subSection = subSection;
        }
        versionSettingsComponent.parentKey = parentKey;
        versionSettingsComponent.parentId = parentId;
        versionSettingsComponent.levelIndex = _.get(currentBasePredefinedGameComponent, "levelIndex", null);
        versionSettingsComponent.linkedLevelSelector = _.get(predefinedGameComponentDetail, "linkedLevelSelector", null);
        versionSettingsComponent.children = [];

        // Auto-split settings between the shared container node and per-level child nodes,
        // mirroring the game config: settings that get pathPrefix'd are level-specific, while
        // pathPrefix-exempt settings (assets and skipPathPrefix) stay general/shared.
        if (currentBasePredefinedGameComponent.isLevelContainer) {
          versionSettingsComponent.settings = versionSettingsComponent.settings.filter(isSharedLevelSetting);
        } else if (currentBasePredefinedGameComponent.isLevelChild) {
          versionSettingsComponent.settings = versionSettingsComponent.settings.filter((s) => !isSharedLevelSetting(s));
        }

        // Apply pathDetails BEFORE pathPrefix so matching works against original (unprefixed) paths
        const pathDetails = _.get(currentBasePredefinedGameComponents[i], "pathDetails", []);
        const settingsWithNewPath = new Set();
        if (pathDetails.length > 0) {
          pathDetails.forEach((pathDetail) => {
            const index = _.findIndex(versionSettingsComponent.settings, (e) => {
              return e.path === pathDetail.path;
            });
            if (index > -1) {
              // Override the setting's path if newPath is provided (skips pathPrefix for this setting)
              if (_.has(pathDetail, "newPath")) {
                versionSettingsComponent.settings[index].path = pathDetail.newPath;
                settingsWithNewPath.add(index);
              }
              // Per-base opt-in for shared components (e.g. allow .zip uploads on one
              // game's background music, or collapse an image set to a single upload,
              // without touching the other bases using the same component)
              if (_.has(pathDetail, "allowZip")) {
                versionSettingsComponent.settings[index].allowZip = pathDetail.allowZip;
              }
              if (_.has(pathDetail, "singleUpload")) {
                versionSettingsComponent.settings[index].singleUpload = pathDetail.singleUpload;
              }
              if (_.has(versionSettingsComponent.settings[index], "destination")) {
                versionSettingsComponent.settings[index].destination = pathDetail.destination;
              } else if (_.has(versionSettingsComponent.settings[index], "destinations")) {
                // for selectorAtlas and selectorImageSet
                versionSettingsComponent.settings[index].destinations = pathDetail.destinations;
              } else {
                console.error("Path detail does NOT have destination or destinations field", pathDetail);
              }
            }
          });
        }

        // Apply pathPrefix to all settings paths if provided (used for levelConfigs per-level data)
        // Skip settings that already received a newPath via pathDetails
        // Skip selectedImages.*, selectedAtlases.* and selectedSpines.* paths - these must always stay at root level
        // Skip settings with skipPathPrefix: true
        const pathPrefix = _.get(currentBasePredefinedGameComponent, "pathPrefix", null);
        if (pathPrefix) {
          versionSettingsComponent.settings.forEach((setting, index) => {
            if (!settingsWithNewPath.has(index) &&
              !setting.path.startsWith("selectedImages.") &&
              !setting.path.startsWith("selectedAtlases.") &&
              !setting.path.startsWith("selectedSpines.") &&
              !setting.skipPathPrefix) {
              setting.path = `${pathPrefix}.${setting.path}`;
            }
          });
        }
        // Collect enabledByComponent mappings for build size calculation
        versionSettingsComponent.settings.forEach((setting) => {
          if (setting.enabledByComponent && setting.path) {
            const assetKey = setting.path.split(".").pop();
            if (!modifiedBase.assetEnabledByComponent) {
              modifiedBase.assetEnabledByComponent = {};
            }
            if (!modifiedBase.assetEnabledByComponent[id]) {
              modifiedBase.assetEnabledByComponent[id] = {};
            }
            modifiedBase.assetEnabledByComponent[id][assetKey] = setting.enabledByComponent;
          }
        });

        modifiedBase.versionSettings.components.splice(0, 0, versionSettingsComponent);

        // GROUPS VERSION SETTINGS
        groups.forEach((group) => {
          let groupSettings = _.remove(versionSettingsComponent.settings, (e) => {
            return e.group === group.name;
          });
          if (groupSettings.length < 1) return;
          // console.log("enters here", group, groupSettings);

          // SUB GROUP VERSION SETTINGS
          const subGroups = group.subGroups ?? [];
          let subGroupComponents = [];

          subGroups.forEach(subGroup => {
            const subGroupSettings = groupSettings.filter(setting => setting.subGroup === subGroup.name);
            if (subGroupSettings.length === 0) return;

            const subGroupComponent = {
              id,
              caption: subGroup.name,
              isGroup: false,
              isSubGroup: true,
              parentGroup: group.name,
              settings: subGroupSettings,
              subSection,
              section,
              parentKey: key,
              levelIndex: currentMapIndex,
              minCount: subGroup.minCount,
              maxCount: subGroup.maxCount,
              children: []
            };

            groupSettings = groupSettings.filter(setting => !subGroupSettings.includes(setting));
            subGroupComponents.push(subGroupComponent);
          });

          const groupComponent = {
            id,
            caption: group.name,
            isBelongToArray: group.isBelongToArray,
            isGroup: true,
            isSubGroup: false,
            settings: groupSettings,
            subSection,
            section,
            parentKey: key,
            levelIndex: currentMapIndex,
            minCount: group.minCount,
            maxCount: group.maxCount,
            children: []
          };

          if (group.isBelongToArray) {
            const arrayPath = group.arrayPath;
            const array = _.get(selectedVersion.gameConfig.components[id], arrayPath, []);
            const count = array.length;
            if (count < 1) {
              console.error("ARRAY GROUP ELEMENT COUNT IS LESS THAN ONE.");
            }
            // console.log("enters here group array", array);
            for (let i = 0; i < count; i++) {
              const clone = _.cloneDeep(groupComponent);
              clone.caption += " " + (i + 1);
              clone.settings.forEach((setting) => {
                setting.path = `${arrayPath}[${i}].${setting.path}`;
              });
              modifiedBase.versionSettings.components.push(clone);
            }
          } else {
            modifiedBase.versionSettings.components.push(groupComponent);

            if (subGroupComponents.length >= 0) { // ADD SUB GROUP DATA IF EXISTS
              modifiedBase.versionSettings.components.push(...subGroupComponents);
            }
          }
        });
      }

      // LOCALIZATION SETTINGS
      if (_.has(predefinedGameComponentDetail, "localizationSettings")) {
        const localizationSettingsComponentsClone = _.cloneDeep(
          predefinedGameComponentDetail.localizationSettings.components
        );
        const ignoredLocalizationSettingsPath = _.get(
          currentBasePredefinedGameComponent,
          "ignoredPaths.localizationSettings",
          []
        );
        localizationSettingsComponentsClone.forEach((component) => {
          component.settings = component.settings.filter((setting) => {
            return !ignoredLocalizationSettingsPath.includes(setting.path);
          });
        });
        const localizationSettingsComponent = localizationSettingsComponentsClone[0];
        if (_.isNil(localizationSettingsComponent)) {
          console.log({ localizationSettingsComponentsClone, id });
        }
        localizationSettingsComponent.id = id;
        localizationSettingsComponent.key = key;
        localizationSettingsComponent.caption = caption;
        localizationSettingsComponent.section = section;
        if (!_.isNil(subSection)) {
          localizationSettingsComponent.subSection = subSection;
        }
        localizationSettingsComponent.parentKey = parentKey;
        localizationSettingsComponent.parentId = parentId;
        localizationSettingsComponent.levelIndex = _.get(currentBasePredefinedGameComponent, "levelIndex", null);
        localizationSettingsComponent.children = [];

        // Auto-split localization settings between the shared container and per-level child nodes.
        if (currentBasePredefinedGameComponent.isLevelContainer) {
          localizationSettingsComponent.settings = localizationSettingsComponent.settings.filter(isSharedLevelSetting);
        } else if (currentBasePredefinedGameComponent.isLevelChild) {
          localizationSettingsComponent.settings = localizationSettingsComponent.settings.filter((s) => !isSharedLevelSetting(s));
        }

        // Apply pathPrefix to localization settings paths if provided (used for levelConfigs per-level data)
        // Skip settings with skipPathPrefix: true
        const locPathPrefix = _.get(currentBasePredefinedGameComponent, "pathPrefix", null);
        if (locPathPrefix) {
          localizationSettingsComponent.settings.forEach((setting) => {
            if (!setting.skipPathPrefix) {
              setting.path = `${locPathPrefix}.${setting.path}`;
            }
          });
        }

        modifiedBase.localizationSettings.components.splice(0, 0, localizationSettingsComponent);
        // GROUPS LOCALIZATION SETTINGS
        groups.forEach((group) => {
          const groupSettings = _.remove(localizationSettingsComponent.settings, (e) => {
            return e.group === group.name;
          });
          if (groupSettings.length < 1) return;
          const groupComponent = {
            id,
            caption: group.name,
            isBelongToArray: false, // is not supported for localization
            isGroup: true,
            settings: groupSettings,
            subSection,
            section,
            parentKey: key,
            minCount: group.minCount,
            maxCount: group.maxCount,
            children: []
          };
          modifiedBase.localizationSettings.components.push(groupComponent);
        });
      }
      // GAME CONFIG
      if (_.has(predefinedGameComponentDetail, "gameConfig") && base.hasOwnProperty("gameConfig")) {
        const gameConfigComponentsClone = _.cloneDeep(predefinedGameComponentDetail.gameConfig.components);
        Object.entries(gameConfigComponentsClone).forEach(([componentId, componentValues], index, array) => {
          const currentId = array.length === 1 ? id : componentId;
          Object.entries(componentValues).forEach(([key, value]) => {
            // if base does not have key, its value set from base game config.
            const baseValue = _.get(modifiedBase.gameConfig.components, `${currentId}.${key}`, null);
            // console.log({ currentId, key, isNil: baseValue });
            if (baseValue === null) {
              _.set(modifiedBase.gameConfig.components, `${currentId}.${key}`, value);
            }
          });
        });
      }
    }

    if (anyChange) {
      setSelectedModifiedBase(modifiedBase);
      // console.log("modified base", modifiedBase);
    }
    // console.log({ modifiedBase });
    return modifiedBase;
  }

  const areObjectsEqual = function (obj1, obj2, ignore) {
    if (typeof obj1 !== typeof obj2) return false;

    if (typeof obj1 !== "object") return obj1 === obj2;

    const keys = Object.keys(obj1);
    for (let idx = 0; idx < keys.length; idx++) {
      const value = keys[idx];
      if (_.isNil(obj1[value]) || _.isNil(obj2[value])) {
        return false;
      } else {
        if (typeof obj1[value] === "object") {
          if (!areObjectsEqual(obj1[value], obj2[value], ignore)) return false;
        } else {
          if (value !== ignore) {
            if (!areObjectsEqual(obj1[value], obj2[value], ignore)) return false;
          }
        }
      }
    }
    return true;
  };

  const getDefaultVersion = function (version) {
    setDefaultVersion(version);
  };

  const insertNewVersion = function (newSelectedVersion, oldVersion) {
    // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────────
    if (_.get(selectedBase, "playEngineInstance", false)) {
      const newVersions = _.clone(versions);
      newVersions.push(newSelectedVersion);
      setVersions(newVersions);

      if (hierarchyEnabled) {
        const parentId = resolveFolderParentId(selectedFolderId);
        setVersionHierarchy((prev) => {
          const next = addVersionToTree(prev, newSelectedVersion, parentId);
          void saveHierarchy(
            selectedBase._id,
            localStorage.getItem("user.companyID"),
            next
          );
          return next;
        });
        setSelectedFolderId(9999999);
      } else {
        const newNode = {
          id: String(newSelectedVersion._id),
          parent: 0,
          text: newSelectedVersion.title,
          data: {
            fileType: "text",
            createdDate: formatNodeDate(newSelectedVersion.dateCreated) || formatNodeDate(new Date()),
            updateDate: formatNodeDate(newSelectedVersion.dateUpdated) || formatNodeDate(new Date()),
          },
        };
        setVersionHierarchy((prev) => (Array.isArray(prev) ? [...prev, newNode] : [newNode]));
      }

      setSelectedVersion(newSelectedVersion);
      localStorage.setItem("selectedVersionID", _.get(newSelectedVersion, "_id", ""));
      return;
    }
    // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────────
    setIsVersionBeingUpdatedFalse(oldVersion)
      .then((_newVersions) => {
        const newVersions = _.clone(_newVersions);
        console.log({
          messages: "version added. the array is: ",
          newVersions
        });
        let defaultGameConfig = addDefaultImagesToGameConfig(_.get(newSelectedVersion, "gameConfig"));
        setSelectedVersionPathValueWithVersion({ path: "gameConfig", value: defaultGameConfig }, newSelectedVersion);

        _.set(newSelectedVersion, "gameConfig", defaultGameConfig);
        newVersions.push(newSelectedVersion);
        setVersions(newVersions);

        ReactGA.event({
          category: "Version",
          action: "Version Created",
          label:
            "game: " + selectedGame.title + ", base: " + selectedBase.title + ", version: " + newSelectedVersion.title,
          dimension1: localStorage.getItem("user.id")
        });
        ReactGA4.event({
          category: "Version",
          action: "Version Created",
          label:
            "game: " + selectedGame.title + ", base: " + selectedBase.title + ", version: " + newSelectedVersion.title,
          dimension1: localStorage.getItem("user.id")
        });
        setSelectedVersion(newSelectedVersion);
        applyPreview({
          newGameConfig: _.get(newSelectedVersion, "gameConfig", {}),
          selectedBase: _.has(selectedBase, "predefinedGameComponents")
            ? _.isNil(selectedModifiedBase)
              ? processPredefinedGameComponentsToBase(selectedBase)
              : selectedModifiedBase
            : selectedBase
        });
      })
      .catch(console.err);
  };

  const insertDuplicatedVersion = function (newSelectedVersion, sourceVersionId) {
    // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────────
    if (!_.get(selectedBase, "playEngineInstance", false)) {
      return;
    }

    const newVersions = _.clone(versions);
    newVersions.push(newSelectedVersion);
    setVersions(newVersions);
    setSelectedVersion(newSelectedVersion);
    localStorage.setItem("selectedVersionID", _.get(newSelectedVersion, "_id", ""));

    const sourceNode = (versionHierarchy || []).find(
      (n) => String(n.id) === String(sourceVersionId)
    );
    const parentId = sourceNode ? sourceNode.parent : 0;

    if (hierarchyEnabled) {
      setVersionHierarchy((prev) => {
        const next = addVersionToTree(prev, newSelectedVersion, parentId);
        void saveHierarchy(
          selectedBase._id,
          localStorage.getItem("user.companyID"),
          next
        );
        return next;
      });
    } else {
      const newNode = {
        id: String(newSelectedVersion._id),
        parent: parentId,
        text: newSelectedVersion.title,
        data: {
          fileType: "text",
          createdDate: formatNodeDate(newSelectedVersion.dateCreated) || formatNodeDate(new Date()),
          updateDate: formatNodeDate(newSelectedVersion.dateUpdated) || formatNodeDate(new Date()),
        },
      };
      setVersionHierarchy((prev) => (Array.isArray(prev) ? [...prev, newNode] : [newNode]));
    }
    // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────────
  };

  const setIsVersionBeingUpdatedFalse = function (version) {
    return new Promise((resolve, reject) => {
      if (_.isNil(version) || _.get(version, "lastUpdatingUserID", "") !== localStorage.getItem("user.id")) {
        resolve(versions);
        return;
      }
      persistVersionBeforeSwitch(version)
        .then(() => resolve(versions))
        .catch(reject);
    });
  };
  useEffect(() => {
    if (!_.get(selectedBase, "playEngineInstance", false)) {
      findDefaultVersionID();
    }
  }, [defaultVersionUpdated]);

  const reloadSelectedVersion = (versionID, previousBrokenAssets) => {
    return fetch(getServerUri("version/findOne"), {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        accessToken: localStorage.getItem("session.accessToken"),
        versionID: String(versionID),
      }),
    })
      .then((response) => (response.status === 200 ? response.json() : null))
      .then((fetchedVersion) => {
        if (fetchedVersion) {
          if (Array.isArray(previousBrokenAssets)) {
            const typeToKey = {
              image: "selectedImages",
              video: "selectedVideos",
              sound: "selectedSounds",
              atlas: "selectedAtlases",
              spine: "selectedSpines",
              glb: "selectedGltfs",
            };
            for (const asset of previousBrokenAssets) {
              const key = typeToKey[asset.type];
              if (key) unrepairableAssetKeysRef.current.add(`${key}:${asset.id}`);
            }
          }
          setSelectedVersion(fetchedVersion);
          setVersions((prev) =>
            prev.map((v) => (String(v._id) === String(fetchedVersion._id) ? fetchedVersion : v))
          );
        }
        return fetchedVersion;
      });
  };

  useEffect(() => {
    setBrokenAssets([]);
    setIsDialogConfirmRefreshOpen(false);
    isBrokenPopupOpenRef.current = false;
  }, [_.get(selectedVersion, "_id")]);

  useEffect(() => {
    if (!selectedVersion || !areMediaLoaded || !areAtlasesLoaded || !areSpinesLoaded || !areBitmapFontsLoaded || !areSoundsLoaded || !areVideosLoaded || !areGlbsLoaded) return;
    const versionID = String(_.get(selectedVersion, "_id", ""));
    if (!versionID) return;

    const gameConfig = _.get(selectedVersion, "gameConfig");
    if (!gameConfig) return;

    const existingSets = {
      selectedImages: new Set((_.get(media, "images", []) || []).map((x) => String(x._id))),
      selectedVideos: new Set((videos || []).map((x) => String(x._id))),
      selectedSounds: new Set((sounds || []).map((x) => String(x._id))),
      selectedAtlases: new Set((atlases || []).map((x) => String(x._id))),
      selectedSpines: new Set((spines || []).map((x) => String(x._id))),
      selectedGltfs: new Set((glbs || []).map((x) => String(x._id))),
    };
    const typeByKey = {
      selectedImages: "image",
      selectedVideos: "video",
      selectedSounds: "sound",
      selectedAtlases: "atlas",
      selectedSpines: "spine",
      selectedGltfs: "glb",
    };

    const componentCaptionMap = {};
    const collectFromComponentsArray = (arr) => {
      if (!Array.isArray(arr)) return;
      for (const comp of arr) {
        if (comp && comp.id && comp.caption && !componentCaptionMap[comp.id]) {
          componentCaptionMap[comp.id] = comp.caption;
        }
      }
    };
    const collectFromBaseLike = (baseLike) => {
      if (!baseLike) return;
      collectFromComponentsArray(_.get(baseLike, "versionSettings.components"));
      collectFromComponentsArray(_.get(baseLike, "localizationSettings.components"));
    };

    collectFromBaseLike(selectedModifiedBase);
    collectFromBaseLike(selectedBase);
    collectFromComponentsArray(_.get(selectedBase, "predefinedGameComponents"));

    if (Array.isArray(predefinedGameComponents)) {
      for (const detail of predefinedGameComponents) collectFromBaseLike(detail);
    }

    const seen = new Set();
    const broken = [];
    const components = _.get(gameConfig, "components", {});
    for (const [componentId, component] of Object.entries(components)) {
      const componentCaption = componentCaptionMap[componentId] || componentId;
      for (const key of Object.keys(existingSets)) {
        const assetGroups = _.get(component, key);
        if (!assetGroups) continue;
        for (const assetArray of Object.values(assetGroups)) {
          if (!Array.isArray(assetArray)) continue;
          for (const entry of assetArray) {
            const id = _.get(entry, "_id");
            if (!id) continue;
            const idStr = String(id);
            if (existingSets[key].has(idStr)) continue;
            // Cross-check: if asset exists in another collection, it's misplaced but not broken
            if (Object.keys(existingSets).some((otherKey) => otherKey !== key && existingSets[otherKey].has(idStr))) continue;
            const dedupeKey = `${key}:${idStr}`;
            if (seen.has(dedupeKey)) continue;
            if (unrepairableAssetKeysRef.current.has(dedupeKey)) continue;
            seen.add(dedupeKey);
            const rawFile = _.get(entry, "file", "");
            const baseName = _.get(entry, "uploadedFileName") || _.get(entry, "name") || _.get(entry, "animationSet");
            let displayName = baseName || rawFile;
            if (baseName && !baseName.includes(".") && rawFile.includes(".")) {
              displayName = baseName + rawFile.slice(rawFile.lastIndexOf("."));
            }
            broken.push({
              type: typeByKey[key],
              id: idStr,
              file: displayName,
              componentCaption,
            });
          }
        }
      }
    }

    if (broken.length > 0) {
      setBrokenAssets(broken);
      setIsDialogConfirmRefreshOpen(true);
      isBrokenPopupOpenRef.current = true;
    }
  }, [selectedVersion, selectedBase, selectedModifiedBase, predefinedGameComponents, areMediaLoaded, areAtlasesLoaded, areSpinesLoaded, areBitmapFontsLoaded, areSoundsLoaded, areVideosLoaded, areGlbsLoaded]);

  useEffect(() => {
    // İlk yüklenme için event listener ekleme
    handleResize();
    window.addEventListener("resize", handleResize);

    // Component kaldırıldığında event listener'ı temizleme
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [heightInPx]);
  useEffect(() => {
    //getRecordingPermissionEveryTime
    if (column1TopRef.current) {
      const height = column1TopRef.current.clientHeight;
      setHeightInPx(height); // Component yüklendikten sonra  yüksekliği alıyo
    }
    validateToken()
      .then(() => {
        setArePermissionsLoaded(true);
        fetchPlans().then(() => {
          fetchAndUpdateCompanySubscription().then((fetchedCompany) => {
            fetchCompanyPermissions().then(() => {
              fetchPredefinedGameComponents().then(() => {
                fetchGames()
                  .then((fetchedGames) => {
                    // A company with no bases granted reaches no games either.
                    // The base and version chain below walks from a game, so
                    // there is nothing here to do; the loading flags are
                    // resolved by the selectedGame / selectedBase effects.
                    if (_.size(fetchedGames) === 0) {
                      return;
                    }
                    let initialSelectedGame = fetchedGames[0];
                    if (!_.isNil(localStorage.getItem("selectedGameID"))) {
                      const lastSelectedGame = fetchedGames.filter(
                        (game) => _.get(game, "_id") === localStorage.getItem("selectedGameID")
                      )[0];
                      if (!_.isNil(lastSelectedGame)) {
                        initialSelectedGame = lastSelectedGame;
                      }
                    }
                    fetchBases(String(initialSelectedGame._id))
                      .then((fetchedBases) => {
                        let initialSelectedBase = fetchedBases[0];
                        if (!_.isNil(localStorage.getItem("selectedBaseID"))) {
                          const lastSelectedBase = fetchedBases.filter(
                            (base) => _.get(base, "_id") === localStorage.getItem("selectedBaseID")
                          )[0];
                          if (!_.isNil(lastSelectedBase)) {
                            initialSelectedBase = lastSelectedBase;
                            setVersionHierarchy(dummyTree);
                            setSelectedBase(initialSelectedBase);

                            processPredefinedGameComponentsToBase(initialSelectedBase);
                            setSelectedFolderId(9999999);
                          }
                        }

                        fetchVersions(String(initialSelectedBase._id), localStorage.getItem("user.companyID"), initialSelectedBase)
                          .then((fetchedVersions) => {
                            if (_.size(fetchedVersions) === 0) {
                              setIsInsertVersionDialogOpen(true);
                            }
                          })
                          .catch(console.error);
                      })
                      .catch(console.error);
                  })
                  .catch(console.error);
                fetchImages()
                  .then((fetchedImages) => {
                    setAreMediaLoaded(true);
                  })
                  .catch(console.error);
                fetchAtlases()
                  .then((fetchedAtlases) => {
                    setAreAtlasesLoaded(true);
                  })
                  .catch(console.error);
                fetchSpines()
                  .then((fetchedSpines) => {
                    setAreSpinesLoaded(true);
                  })
                  .catch(console.error);
                fetchBitmapFonts()
                  .then(() => {
                    setAreBitmapFontsLoaded(true);
                  })
                  .catch(console.error);
                fetchSounds()
                  .then((fetchedSounds) => {
                    setAreSoundsLoaded(true);
                  })
                  .catch(console.error);
                fetchFonts()
                  .then((fetchedFonts) => {
                    setAreFontsLoaded(true);
                  })
                  .catch(console.error);
                fetchVideos()
                  .then((fetchedVideos) => {
                    setAreVideosLoaded(true);
                  })
                  .catch(console.error);
                fetchGlbs()
                  .then((fetchedGlbs) => { })
                  .catch(console.error);
              });
            });
          });
        });
      })
      .catch((err) => {
        console.error(err);
        window.location = "/login";
      });
  }, []);

  const selectedGameID = _.get(selectedGame, "_id");
  useEffect(() => {
    setAreBasesLoaded(false);
    if (!selectedGameID) {
      // No game means no base to pick, which is the normal state of a company
      // that has not been granted any bases yet. The flag still has to resolve,
      // or the loading gate below never opens.
      setBases([]);
      setSelectedBase(null);
      setAreBasesLoaded(true);
      return;
    }
    if (selectedGameID) {
      setVersionHierarchy(dummyTree);
      setSelectedBase(null);
      setSelectedModifiedBase(null);

      setSelectedVersion(null);
      // The versions still in state belong to the previous base. Without clearing
      // this flag the loading gate can open again (bases resolve before the new
      // base is applied) and mount the version machinery with a null base.
      setAreVersionsLoaded(false);
      fetchBases(selectedGameID).then((fetchedBases) => {
        setBases(fetchedBases);
        setAreBasesLoaded(true);
        if (_.size(fetchedBases) > 0) {
          if (!_.isNil(localStorage.getItem("selectedBaseID"))) {
            const userSelectedBase = fetchedBases.filter(
              (base) => _.get(base, "_id") === localStorage.getItem("selectedBaseID")
            )[0];
            if (!_.isNil(userSelectedBase)) {
              setVersionHierarchy(dummyTree);
              setSelectedBase(userSelectedBase);
              setSelectedFolderId(9999999);
            } else {
              setVersionHierarchy(dummyTree);
              setSelectedBase(fetchedBases[0]);
              setSelectedFolderId(9999999);

              if (!_.isNil(_.get(fetchedBases[0], "_id"))) {
                localStorage.setItem("selectedBaseID", _.get(fetchedBases[0], "_id"));
              }
            }
          } else {
            setVersionHierarchy(dummyTree);
            setSelectedBase(fetchedBases[0]);
            setSelectedFolderId(9999999);

            if (!_.isNil(_.get(fetchedBases[0], "_id"))) {
              localStorage.setItem("selectedBaseID", _.get(fetchedBases[0], "_id"));
            }
          }

          ReactGA.event({
            category: "Game",
            action: "Game Changed",
            label: "game: " + selectedGame.title,
            dimension1: localStorage.getItem("user.id")
          });
          ReactGA4.event({
            category: "Game",
            action: "Game Changed",
            label: "game: " + selectedGame.title,
            dimension1: localStorage.getItem("user.id")
          });
        }
      });
    }
  }, [selectedGameID]);

  const selectedBaseID = _.get(selectedBase, "_id");

  useEffect(() => {
    // No base at all — a company with an empty grant. Everything below reads a
    // base, so resolve the flags the loading gate waits on and stop here.
    if (_.isNil(selectedBase)) {
      setSelectedVersion(null);
      setAreVersionsLoaded(true);
      setAreMediaLoaded(true);
      setAreAtlasesLoaded(true);
      setAreBitmapFontsLoaded(true);
      setAreSoundsLoaded(true);
      setAreFontsLoaded(true);
      setAreVideosLoaded(true);
      return;
    }
    // The snapshot editor works on snapshot files rather than versions and
    // brings its own asset handling, so none of the version/media loading below
    // applies to it. The "loaded" flags are still set, because the page-level
    // isLoading gate waits on them and would otherwise never let the page render.
    // A pe3d base is the same: its variants and releases load in usePe3dEditor.
    // It also drops the previous base's versions, which would otherwise hold
    // the loading gate on a version preview this base never shows.
    if (isSnapshotEditorBase(selectedBase) || isPe3dBase(selectedBase)) {
      if (isPe3dBase(selectedBase)) setVersions([]);
      setSelectedVersion(null);
      setAreVersionsLoaded(true);
      setAreMediaLoaded(true);
      setAreAtlasesLoaded(true);
      setAreBitmapFontsLoaded(true);
      setAreSoundsLoaded(true);
      setAreFontsLoaded(true);
      setAreVideosLoaded(true);
      return;
    }

    setAreVersionsLoaded(false);
    setSelectedVersion(null);
    if (selectedBaseID) {
      fetchVersions(selectedBaseID, localStorage.getItem("user.companyID")).then((fetchedVersions) => {
        setSelectedFolderId(9999999);
        if (_.size(fetchedVersions) === 0) {
          setIsInsertVersionDialogOpen(true);
        } else {
          if (!_.isNil(localStorage.getItem("selectedVersionID"))) {
            const userSelectedVersion = fetchedVersions.filter(
              (version) => _.get(version, "_id") === localStorage.getItem("selectedVersionID")
            )[0];
            if (!_.isNil(userSelectedVersion)) {
              setSelectedVersion(userSelectedVersion);
            } else {
              setSelectedVersion(fetchedVersions[0]);
              if (!_.isNil(_.get(fetchedVersions[0], "_id"))) {
                localStorage.setItem("selectedVersionID", _.get(fetchedVersions[0], "_id"));
              }
            }
          } else {
            setSelectedVersion(fetchedVersions[0]);
            if (!_.isNil(_.get(fetchedVersions[0], "_id"))) {
              localStorage.setItem("selectedVersionID", _.get(fetchedVersions[0], "_id"));
            }
          }
          ReactGA.event({
            category: "Game",
            action: "Base Changed",
            label: "game: " + selectedGame.title + "base: " + selectedBase.title,
            dimension1: localStorage.getItem("user.id")
          });
          ReactGA4.event({
            category: "Game",
            action: "Base Changed",
            label: "game: " + selectedGame.title + "base: " + selectedBase.title,
            dimension1: localStorage.getItem("user.id")
          });
        }
      });
      fetchImages()
        .then((fetchedImages) => {
          setAreMediaLoaded(true);
        })
        .catch(console.error);
      fetchAtlases()
        .then((fetchedAtlases) => {
          setAreAtlasesLoaded(true);
        })
        .catch(console.error);
      fetchSpines()
        .then((fetchedSpines) => {
          setAreSpinesLoaded(true);
        })
        .catch(console.error);
      fetchBitmapFonts()
        .then(() => {
          setAreBitmapFontsLoaded(true);
        })
        .catch(console.error);
      fetchSounds()
        .then((fetchedSounds) => {
          setAreSoundsLoaded(true);
        })
        .catch(console.error);
      fetchFonts()
        .then((fetchedFonts) => {
          setAreFontsLoaded(true);
        })
        .catch(console.error);
      fetchVideos()
        .then((fetchedFonts) => {
          setAreVideosLoaded(true);
        })
        .catch(console.error);
      fetchGlbs()
        .then((fetchedGlbs) => { })
        .catch(console.error);
    }
  }, [selectedBaseID]);

  const selectedVersionID = _.get(selectedVersion, "_id");
  useEffect(() => {
    if (selectedVersion) {
      ReactGA.event({
        category: "Version",
        action: "Version Changed",
        label: "game: " + selectedGame.title + "base: " + selectedBase.title + "version: " + selectedVersion.title,
        dimension1: localStorage.getItem("user.id")
      });
      ReactGA4.event({
        category: "Version",
        action: "Version Changed",
        label: "game: " + selectedGame.title + "base: " + selectedBase.title + "version: " + selectedVersion.title,
        dimension1: localStorage.getItem("user.id")
      });
    }
    let isAutoplay = closeAutoplay(prevVersion);
    //notify game that version changed
    if (isAutoplay) {
      doRefresh((prev) => prev + 1);
    } else if (isLegacyBase(selectedBase)) {
      versionChanged();
    }
    setPrevSelectedRecorderSettings(JSON.stringify(_.get(selectedVersion, "recorderSettings", {})));
    setPrevButton(_.get(selectedVersion, "gameConfig.components.autoplay1.startAutoplay"));
    // A pe3d base has no versions and no applyGameConfig preview.
    if (isPe3dBase(selectedBase)) return;
    if (_.get(selectedBase, "playEngineInstance", false)) {
      doRefresh((prev) => prev + 1);
      return;
    }
    if (!_.get(selectedBase, "playEngineInstance", false)) {
      applyPreview({
        newGameConfig: _.get(selectedVersion, "gameConfig", {}),
        selectedBase: _.has(selectedBase, "predefinedGameComponents")
          ? _.isNil(selectedModifiedBase)
            ? processPredefinedGameComponentsToBase(selectedBase)
            : selectedModifiedBase
          : selectedBase
      });
      findDefaultVersionID();
    }
  }, [selectedVersionID]);
  useEffect(() => {
    if (selectedFolderId == 9999999) {
      setMenuLayout(true);
    } else {
      setMenuLayout(false);
    }
  }, [selectedFolderId]);

  useEffect(() => {
    if (!_.isNil(_.get(selectedGame, "_id"))) {
      localStorage.setItem("selectedGameID", _.get(selectedGame, "_id"));
    }
  }, [selectedGame]);

  useEffect(() => {
    if (!_.isNil(_.get(selectedBase, "_id"))) {
      setPortrait(true);
      setHierarchyEnabled(false);
      localStorage.setItem("selectedBaseID", _.get(selectedBase, "_id"));
    }

    processPredefinedGameComponentsToBase(selectedBase);
  }, [selectedBase]);
  useEffect(() => {
    if (versionHierarchy != null) {
      setOTreeData(versionHierarchy);
      setTreeData(versionHierarchy);
    }
  }, [versionHierarchy]);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  //FEAT-2
  const handleResize = () => {
    if (column1TopRef.current) {
      const height = column1TopRef.current.clientHeight;
      setHeightInPx(height);
    }
  };
  function applyDialogHierarchyUpdate(value) {
    if (value && Array.isArray(value.tree)) {
      setVersionHierarchy(value.tree);
    } else if (Array.isArray(value)) {
      setVersionHierarchy(value);
    }
  }

  function setDialogVersionHierarchy(value) {
    // ── PLAYENGINE BRANCH ───────────────────────────────────────────────────
    if (_.get(selectedBase, "playEngineInstance", false)) {
      applyDialogHierarchyUpdate(value);
      return;
    }
    // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────
    setUpdateTreeOpen(value);
  }

  function deleteVersionFromView(versionID, isMultiple = false, multipleVersion = [], folderId = null) {
    //find the version

    let isVersionFound = false;
    versions.forEach((versionRecord) => {
      if (String(_.get(versionRecord, "_id")) === String(versionID)) {
        isVersionFound = true;
        ReactGA.event({
          category: "Version",
          action: "Version Deleted",
          label: "game: " + selectedGame.title + "base: " + selectedBase.title + "version: " + versionRecord.title,
          dimension1: localStorage.getItem("user.id")
        });
        ReactGA4.event({
          category: "Version",
          action: "Version Deleted",
          label: "game: " + selectedGame.title + "base: " + selectedBase.title + "version: " + versionRecord.title,
          dimension1: localStorage.getItem("user.id")
        });
      }
    });
    // Regular games keep the original behavior (throw when not found). PlayEngine
    // folder deletes can pass synthetic/empty ids, so skip the throw there.
    if (!isVersionFound && !_.get(selectedBase, "playEngineInstance", false)) {
      throw "VERSION_NOT_FOUND";
    }

    if (isMultiple) {
      let newVersions = _.clone(versions);
      multipleVersion.map((ver) => {
        let filteredVersions = newVersions.filter((versionRecord) => {
          return String(_.get(versionRecord, "_id")) !== ver;
        });

        setVersions(filteredVersions);
        if (_.size(filteredVersions) === 0) {
          setIsInsertVersionDialogOpen(true);
          setSelectedVersion(null);
        } else {
          let notSelected = true;
          for (let i = 0; i < filteredVersions.length; i++) {
            if (filteredVersions[i]._id == selectedVersionID) {
              notSelected = false;
              break;
            }
          }
          if (notSelected) {
            const newSelectedVersion = filteredVersions[0];
            //FEAT-2
            setSelectedVersion(newSelectedVersion);
          }
          newVersions = filteredVersions;
        }
      });

      // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────
      if (_.get(selectedBase, "playEngineInstance", false) && (hierarchyEnabled || folderId != null)) {
        setVersionHierarchy((prev) => {
          const next =
            folderId != null
              ? removeFolderFromTree(prev, folderId)
              : multipleVersion.reduce(
                (tree, id) => removeVersionFromTree(tree, id),
                prev
              );
          if (hierarchyEnabled) {
            void saveHierarchy(
              selectedBase._id,
              localStorage.getItem("user.companyID"),
              next
            );
          }
          return next;
        });
      }
      // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────
    } else {
      let newVersions = _.clone(versions);

      let filteredVersions = newVersions.filter((versionRecord) => {
        return String(_.get(versionRecord, "_id")) !== versionID;
      });

      // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────
      // For playEngine bases, also remove the deleted node from versionHierarchy
      // so the list updates immediately without requiring a page refresh.
      if (_.get(selectedBase, "playEngineInstance", false)) {
        setVersionHierarchy((prev) => {
          const next = removeVersionFromTree(prev, versionID);
          if (hierarchyEnabled) {
            void saveHierarchy(
              selectedBase._id,
              localStorage.getItem("user.companyID"),
              next
            );
          }
          return next;
        });
      }
      // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────

      if (_.size(filteredVersions) === 0) {
        setVersions(filteredVersions);
        setIsInsertVersionDialogOpen(true);
        setSelectedVersion(null);
      } else {
        const newSelectedVersion = filteredVersions[0];
        setVersions(filteredVersions);

        //FEAT-2
        setSelectedVersion(newSelectedVersion);
      }
    }
  }

  /**
   * Mirror the fields versionPlayEngine/updateOne stamps server-side onto the
   * version we already hold in state.
   *
   * Refetching the whole list instead would re-download and re-parse every
   * version of the base — each record carries a full playEngineConfig (up to a
   * few MB) — on every debounced keystroke, blocking the main thread the
   * same-origin preview iframe renders on. The list is still refreshed on the
   * events that can actually change it (version/base switch, create, delete,
   * duplicate, preset apply, agent runs).
   */
  function stampPlayEngineVersionSaved(version) {
    if (!version) return;
    version.dateUpdated = new Date();
    const userId = localStorage.getItem("user.id");
    if (userId) version.lastUpdatingUserID = userId;
  }

  async function saveVersionAndApplyPreview(
    { newSelectedVersion },
    isApplyPreview,
    disableUndoStack,
    persistHint
  ) {
    if (!_.has(newSelectedVersion, "_id")) {
      console.warn(
        "skipping saving version because versionid is not selected. " +
        "version will not be saved until you select a version " +
        "or a version is selected automatically"
      );
      return;
    }

    // ── PLAYENGINE BRANCH ─────────────────────────────────────────────────────
    // One save path for playEngine, so the store's record of what is owed cannot
    // drift: the queue sends the owed paths (or the whole config when a path is
    // not addressable) and acknowledges them.
    if (_.get(selectedBase, "playEngineInstance", false)) {
      return persistQueue.flush(docKeyFor(newSelectedVersion), playEnginePersistContext());
    }
    // ── END PLAYENGINE BRANCH ─────────────────────────────────────────────────

    if (newSelectedVersion.isLocked === true) {
      return;
    }

    if (!_.has(newSelectedVersion, "gameConfig")) {
      console.warn("Selected Version has no gameConfig, won't save, won't apply preview");
      return;
    }

    if (!disableUndoStack) {
      if (typeof newSelectedVersion.gameConfig.components.autoplay1 !== "undefined") {
        if (prevButton !== newSelectedVersion.gameConfig.components.autoplay1.startAutoplay) {
          setPrevButton(newSelectedVersion.gameConfig.components.autoplay1.startAutoplay);

          return;
        } else if (prevSelectedRecorderSettings !== JSON.stringify(newSelectedVersion.recorderSettings)) {
          if (!_.isNil(selectedVersion)) {
            undoCtx.pushUndoStack(JSON.stringify(selectedVersion.recorderSettings));
          }
          setPrevSelectedRecorderSettings(JSON.stringify(newSelectedVersion.recorderSettings));
        } else {
          if (!_.isNil(selectedVersion)) {
            undoCtx.pushUndoStack(selectedVersion.gameConfig);
          }
        }
      } else {
        if (!_.isNil(selectedVersion)) {
          undoCtx.pushUndoStack(selectedVersion.gameConfig);
        }
      }
    }

    let createdLanguages = Array.isArray(newSelectedVersion.createdLanguages)
      ? [...newSelectedVersion.createdLanguages]
      : ["en"];

    const activeLanguage = _.get(newSelectedVersion, "gameConfig.options.language", "en");
    if (!createdLanguages.includes("en")) {
      createdLanguages.unshift("en");
    }
    if (!createdLanguages.includes(activeLanguage)) {
      createdLanguages.push(activeLanguage);
    }
    newSelectedVersion.createdLanguages = createdLanguages;

    const fetchUri = getServerUri("version/updateOne");
    const persistPaths =
      persistHint && persistHint.full !== true ? _.get(persistHint, "paths", []) : [];
    let fields = persistPaths.length > 0 ? {} : null;
    persistPaths.forEach((path) => {
      if (fields === null) return;
      const value = _.get(newSelectedVersion, path);
      // JSON.stringify drops undefined, which would silently skip the write;
      // save the whole blob rather than lose it.
      if (_.isUndefined(value)) {
        fields = null;
        return;
      }
      fields[path] = value;
    });
    const bodyParams = {
      accessToken: localStorage.getItem("session.accessToken"),
      versionID: String(_.get(newSelectedVersion, "_id"))
    };
    if (fields !== null) {
      fields.createdLanguages = createdLanguages;
      bodyParams.fields = JSON.stringify(fields);
    } else {
      bodyParams.gameConfig = JSON.stringify(_.get(newSelectedVersion, "gameConfig", []));
      bodyParams.recorderSettings = JSON.stringify(_.get(newSelectedVersion, "recorderSettings") || {});
      bodyParams.lastUpdatingUserID = String(_.get(newSelectedVersion, "lastUpdatingUserID", ""));
      bodyParams.createdLanguages = JSON.stringify(createdLanguages);
    }
    const fetchInit = {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(bodyParams)
    };
    await fetch(fetchUri, fetchInit)
      .then((response) => {
        if (response.status === 200) {
          fetchVersions(newSelectedVersion.baseID, newSelectedVersion.companyID);
          //console.debug("saved version");
        } else if (response.status === 401) {
          createSnackbar("You are not authorized to update, contact your administrator.", "warning");
          response
            .text()
            .then((textResponse) => {
              console.log({ message: "error updating", textResponse });
            })
            .catch(console.error);
        } else if (response.status === 403) {
          createSnackbar("This version is locked. Unlock to edit content.", "warning", false);
        } else {
          response
            .text()
            .then((textResponse) => {
              console.log("version update failed: " + textResponse);
              createSnackbar(
                textResponse ? `Version save failed: ${textResponse}` : "Version save failed.",
                "error",
                false
              );
            })
            .catch(console.error);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    // if (isApplyPreview) {

    //         applyPreview({
    //             newGameConfig: _.get(newSelectedVersion, `gameConfig`, []),
    //             selectedBase
    //         });

    // }
  }

  function getPreviewBase() {
    return _.has(selectedBase, "predefinedGameComponents")
      ? _.isNil(selectedModifiedBase)
        ? processPredefinedGameComponentsToBase(selectedBase)
        : selectedModifiedBase
      : selectedBase;
  }

  /**
   * Path-level iframe update. Falls back to a full applyPreview when the path
   * is not a safe partial (whole gameConfig, copy-all-levels, …).
   */
  function applyCommitPreview(version, path, value) {
    const previewBase = getPreviewBase();
    if (_.get(previewBase, "playEngineInstance", false)) return;

    const patch = buildCommitPreviewPatch(version, path, value);
    if (patch) {
      pushPreviewPatch(patch);
      return;
    }
    applyPreview({
      newGameConfig: _.get(version, "gameConfig", []),
      selectedBase: previewBase
    });
  }

  /**
   * How the playEngine save reports back.
   *
   * A conflict is the agent having written this version while it was open here.
   * `rebaseOnServer` has already kept the edits it did not touch; what the user
   * has to be told is the part that was taken away from them, which is why the
   * collided fields are named rather than counted.
   */
  function playEnginePersistContext() {
    return {
      onSaved: (savedVersion) => {
        stampPlayEngineVersionSaved(savedVersion);
      },
      onConflict: ({ collided, root }) => {
        setSelectedVersion(root);
        setVersions((prev) => {
          const index = prev.findIndex((v) => String(_.get(v, "_id")) === String(_.get(root, "_id")));
          if (index < 0) return prev;
          const next = [...prev];
          next[index] = root;
          return next;
        });
        createSnackbar(
          collided.length
            ? `This version changed while you were editing it — reloaded, and your edits were kept except ${collided
              .map((path) => path.split(".").pop())
              .join(", ")}.`
            : "This version changed while you were editing it — reloaded, and your edits were kept.",
          "warning",
          false
        );
      },
      notify: (message, variant) => createSnackbar(message, variant, false),
    };
  }

  /**
   * Apply path writes to the selected version. PlayEngine bases go through the
   * document store (structural sharing); normal playables keep the deep clone,
   * because their panels mutate config subtrees in place — see the module.
   *
   * @param {object} baseVersion
   * @param {Array<[string, *]>} entries [path, value] pairs
   * @returns {object}
   */
  function applyVersionPaths(baseVersion, entries) {
    return applyVersionPathsToVersion(baseVersion, entries, {
      useDocStore: _.get(selectedBase, "playEngineInstance", false),
    });
  }

  /**
   * How the playEngine save reports back.
   *
   * A conflict is the agent having written this version while it was open here.
   * `rebaseOnServer` has already kept the edits it did not touch; what the user
   * has to be told is the part that was taken away from them, which is why the
   * collided fields are named rather than counted.
   */
  function playEnginePersistContext() {
    return {
      onSaved: (savedVersion) => {
        stampPlayEngineVersionSaved(savedVersion);
      },
      onConflict: ({ collided, root }) => {
        setSelectedVersion(root);
        setVersions((prev) => {
          const index = prev.findIndex((v) => String(_.get(v, "_id")) === String(_.get(root, "_id")));
          if (index < 0) return prev;
          const next = [...prev];
          next[index] = root;
          return next;
        });
        createSnackbar(
          collided.length
            ? `This version changed while you were editing it — reloaded, and your edits were kept except ${collided
              .map((path) => path.split(".").pop())
              .join(", ")}.`
            : "This version changed while you were editing it — reloaded, and your edits were kept.",
          "warning",
          false
        );
      },
      notify: (message, variant) => createSnackbar(message, variant, false),
    };
  }

  /**
   * Apply path writes to the selected version. PlayEngine bases go through the
   * document store (structural sharing); normal playables keep the deep clone,
   * because their panels mutate config subtrees in place — see the module.
   *
   * @param {object} baseVersion
   * @param {Array<[string, *]>} entries [path, value] pairs
   * @returns {object}
   */
  function applyVersionPaths(baseVersion, entries) {
    return applyVersionPathsToVersion(baseVersion, entries, {
      useDocStore: _.get(selectedBase, "playEngineInstance", false),
    });
  }

  /**
   * Generic version update method
   * @param p.path
   * @param p.value
   */
  function setSelectedVersionPathValue(p, resetValue) {
    if (
      !_.get(selectedBase, "playEngineInstance", false) &&
      _.get(selectedVersion, "isLocked") === true
    ) {
      createSnackbar("This version is locked. Unlock to edit content.", "warning", false);
      return;
    }
    let filteredPath = p.path.substr(p.path.indexOf(".") + 1);
    if (_.has(p, "isLanguageChanged") && _.get(p, "isLanguageChanged")) {
      ReactGA.event({
        category: "Version",
        action: "Language Changed",
        label:
          "game: " +
          selectedGame.title +
          ", base: " +
          selectedBase.title +
          ", version: " +
          selectedVersion.title +
          ", path: " +
          filteredPath,
        dimension1: localStorage.getItem("user.id")
      });
      ReactGA4.event({
        category: "Version",
        action: "Language Changed",
        label:
          "game: " +
          selectedGame.title +
          ", base: " +
          selectedBase.title +
          ", version: " +
          selectedVersion.title +
          ", path: " +
          filteredPath,
        dimension1: localStorage.getItem("user.id")
      });
    } else {
      ReactGA.event({
        category: "Version",
        action: "Version Attribute Changed",
        label:
          "game: " +
          selectedGame.title +
          ", base: " +
          selectedBase.title +
          ", version: " +
          selectedVersion.title +
          ", path: " +
          filteredPath,
        dimension1: localStorage.getItem("user.id")
      });
      ReactGA4.event({
        category: "Version",
        action: "Version Attribute Changed",
        label:
          "game: " +
          selectedGame.title +
          ", base: " +
          selectedBase.title +
          ", version: " +
          selectedVersion.title +
          ", path: " +
          filteredPath,
        dimension1: localStorage.getItem("user.id")
      });
    }
    // If a previous synchronous call already built a pending version object,
    // start from that so multiple consecutive calls (e.g. applyPreset setting
    // playEngineConfig then dashboardMeta) accumulate onto the same snapshot
    // instead of each cloning the stale React state and overwriting each other.
    const baseVersion = pendingVersionRef ?? selectedVersion;
    const newSelectedVersion = applyVersionPaths(baseVersion, [[p.path, p.value]]);
    pendingVersionRef = newSelectedVersion;
    setVersions((prev) => {
      const versionIndex = prev.findIndex(
        (value) => _.get(value, "_id") === _.get(selectedVersion, "_id")
      );
      if (versionIndex < 0) return prev;
      const next = [...prev];
      next[versionIndex] = newSelectedVersion;
      return next;
    });

    // Reflect edits in UI immediately; debounce only the DB save.
    setSelectedVersion(newSelectedVersion);

    applyCommitPreview(newSelectedVersion, p.path, p.value);

    // PlayEngine saves are owned by the persist queue: the store already knows
    // which paths are owed, so the queue debounces once for the document rather
    // than once per edit, and sends those paths instead of the whole config.
    if (_.get(selectedBase, "playEngineInstance", false)) {
      persistQueue.schedule(docKeyFor(newSelectedVersion), playEnginePersistContext());
      return;
    }

    pendingPersist = addPersistField(pendingPersist, p.path);

    // PlayEngine saves are owned by the persist queue: the store already knows
    // which paths are owed, so the queue debounces once for the document rather
    // than once per edit, and sends those paths instead of the whole config.
    if (_.get(selectedBase, "playEngineInstance", false)) {
      persistQueue.schedule(docKeyFor(newSelectedVersion), playEnginePersistContext());
      return;
    }

    if (timeoutID !== null) {
      clearTimeout(timeoutID);
    }

    timeoutID = setTimeout(() => {
      const persistHint = pendingPersist;
      const versionToSave = pendingVersionRef ?? newSelectedVersion;
      pendingPersist = null;
      pendingVersionRef = null;
      saveVersionAndApplyPreview({ newSelectedVersion: versionToSave }, true, resetValue, persistHint);
    }, 200);
  }

  /**
   * Persist a path on any version (selected or not) without switching the editor.
   * Used to copy scene-editor layout onto the default version.
   */
  async function persistVersionPathValue(versionId, path, value, fallbackVersion) {
    const key = String(versionId || "");
    if (!key || typeof path !== "string") return false;

    const isSelected = Boolean(selectedVersion && String(_.get(selectedVersion, "_id")) === key);
    const source =
      isSelected && pendingVersionRef
        ? pendingVersionRef
        : versions.find((v) => String(_.get(v, "_id")) === key) ||
        (fallbackVersion && String(_.get(fallbackVersion, "_id")) === key ? fallbackVersion : null);
    if (!source) return false;

    const next = _.cloneDeep(source);
    _.set(next, path, value);

    setVersions((prev) => {
      const idx = prev.findIndex((v) => String(_.get(v, "_id")) === key);
      if (idx < 0) return prev;
      const copy = [...prev];
      copy[idx] = next;
      return copy;
    });

    if (isSelected) {
      pendingVersionRef = next;
      setSelectedVersion(next);
    }

    await saveVersionAndApplyPreview({ newSelectedVersion: next }, false, true);
    return true;
  }

  /**
   * Flush debounced edits and persist the latest in-memory version snapshot.
   * Used before switching versions so pendingVersionRef edits are not lost.
   */
  async function persistVersionBeforeSwitch(fallbackVersion) {
    if (timeoutID !== null) {
      clearTimeout(timeoutID);
      timeoutID = null;
    }
    const toSave = pendingVersionRef ?? fallbackVersion;
    pendingVersionRef = null;
    pendingPersist = null;
    if (!toSave || !_.has(toSave, "_id")) {
      return;
    }
    if (_.get(selectedBase, "playEngineInstance", false)) {
      // The queue holds the owed paths; waiting out its debounce would lose them.
      await persistQueue.flush(docKeyFor(toSave), playEnginePersistContext());
      return;
    }
    if (toSave.isLocked === true) {
      return;
    }
    await saveVersionAndApplyPreview({ newSelectedVersion: _.cloneDeep(toSave) }, true);
  }

  /**
   * Update one version in versions[] by id. When that version is selected, also
   * updates selectedVersion + preview. Use persist:false when the server already
   * saved (e.g. games agent).
   *
   * @param {string} versionId
   * @param {{ path: string, value: * }} p
   * @param {{ persist?: boolean, resetValue?: * }} [options]
   * @returns {boolean} true if the version was found and patched
   */
  function setVersionPathValue(versionId, p, { persist = true, resetValue } = {}) {
    if (!p || typeof p.path !== "string") return false;
    return patchVersionFields(versionId, { [p.path]: p.value }, { persist, resetValue });
  }

  /**
   * Merge multiple top-level version fields in one versions[] update.
   *
   * @param {string} versionId
   * @param {{ gameConfig?: object, createdLanguages?: string[] }} fields
   * @param {{ persist?: boolean, resetValue?: * }} [options]
   * @returns {boolean}
   */
  function patchVersionFields(versionId, fields, { persist = true, resetValue } = {}) {
    const key = String(versionId || "");
    if (!key || !fields || typeof fields !== "object") return false;

    const entries = Object.entries(fields).filter(([, value]) => value != null);
    if (entries.length === 0) return false;

    const isSelected = Boolean(
      selectedVersion && String(_.get(selectedVersion, "_id")) === key
    );

    let updatedVersion = null;
    setVersions((prev) => {
      const versionIndex = prev.findIndex((v) => String(_.get(v, "_id")) === key);
      if (versionIndex < 0) return prev;
      const base = isSelected && pendingVersionRef ? pendingVersionRef : prev[versionIndex];
      updatedVersion = applyVersionPaths(base, entries);
      const next = [...prev];
      next[versionIndex] = updatedVersion;
      return next;
    });

    if (!updatedVersion) return false;

    if (!isSelected) return true;

    if (!persist) {
      if (timeoutID !== null) {
        clearTimeout(timeoutID);
        timeoutID = null;
      }
      pendingVersionRef = null;
      pendingPersist = null;
    } else {
      pendingVersionRef = updatedVersion;
      entries.forEach(([path]) => {
        pendingPersist = addPersistField(pendingPersist, path);
      });
    }

    setSelectedVersion(updatedVersion);
    if (entries.length === 1) {
      applyCommitPreview(updatedVersion, entries[0][0], entries[0][1]);
    } else {
      applyPreview({
        newGameConfig: _.get(updatedVersion, "gameConfig", []),
        selectedBase: getPreviewBase()
      });
    }

    if (!persist) return true;

    if (_.get(selectedBase, "playEngineInstance", false)) {
      persistQueue.schedule(docKeyFor(updatedVersion), playEnginePersistContext());
      return true;
    }

    if (timeoutID !== null) {
      clearTimeout(timeoutID);
    }

    timeoutID = setTimeout(() => {
      const persistHint = pendingPersist;
      const versionToSave = pendingVersionRef ?? updatedVersion;
      pendingPersist = null;
      pendingVersionRef = null;
      saveVersionAndApplyPreview({ newSelectedVersion: versionToSave }, true, resetValue, persistHint);
    }, 200);
    return true;
  }

  /**
   * Close autoplay of previous version method
   * @param p.path
   * @param p.value
   * @param version previous version
   */
  function setSelectedVersionPathValueWithVersion(p, version) {
    const newSelectedVersion = _.cloneDeep(version);
    _.set(newSelectedVersion, p.path, p.value);
    const versionIndex = versions.findIndex((value) => {
      return _.get(value, "_id") === _.get(version, "_id");
    });
    versions[versionIndex] = newSelectedVersion;
    saveVersionAndApplyPreview({ newSelectedVersion }, false);
  }

  /**
   * Entries whose `_id` is already in `list` — an import that reuses an existing
   * media record reports it just like a freshly created one, and adding it twice
   * would show it twice in the media library.
   *
   * @param {Array} list
   * @param {Array} value
   */
  function withoutKnownRecords(list, value) {
    const knownIds = new Set((list || []).map((item) => String(_.get(item, "_id"))));
    return (value || []).filter((item) => !knownIds.has(String(_.get(item, "_id"))));
  }

  /**
   * @param {String} p.path
   * @param {Array} p.value
   */
  function insertMediaPathValue(p) {
    let newMedia = _.cloneDeep(media);
    if (!_.has(newMedia, p.path)) {
      _.set(newMedia, p.path, []);
    }
    const target = _.get(newMedia, p.path);
    target.push(...withoutKnownRecords(target, p.value));
    setMedia(newMedia);
  }

  function deleteImageFromMedia(imageID) {
    let newMedia = _.cloneDeep(media);
    if (_.isNil(newMedia)) {
      console.error("newMedia is null");
      return;
    }
    if (!_.has(newMedia, "images")) {
      _.set(newMedia, "images", []);
    }
    newMedia.images = newMedia.images.filter((image) => image._id !== imageID);
    setMedia(newMedia);
  }

  function deleteImageSetFromMedia(imageSetID) {
    let newMedia = _.cloneDeepWith(media);
    if (!_.has(newMedia, "images")) {
      _.set(newMedia, "images", []);
    }
    newMedia.images = newMedia.images.filter((image) => image.imageSet !== imageSetID);
    setMedia(newMedia);
  }

  function insertAtlasPathValue(value) {
    let newAtlases = _.cloneDeep(atlases);
    newAtlases.push(...value);

    setAtlases(newAtlases);
  }

  function insertSpinePathValue(value) {
    let newSpines = _.cloneDeep(spines);
    newSpines.push(...value);

    setSpines(newSpines);
  }

  function insertBitmapFontPathValue(value) {
    let newBitmapFonts = _.cloneDeep(bitmapFonts);
    newBitmapFonts.push(...withoutKnownRecords(newBitmapFonts, value));

    setBitmapFonts(newBitmapFonts);
  }

  function insertSoundPathValue(value) {
    let newSounds = _.cloneDeep(sounds);
    newSounds.push(...value);

    setSounds(newSounds);
  }

  function insertFontPathValue(value) {
    let newFonts = _.cloneDeep(fonts);
    newFonts.push(...value);

    setFonts(newFonts);
  }

  function insertVideoPathValue(value) {
    let newVideos = _.cloneDeep(videos);
    newVideos.push(...withoutKnownRecords(newVideos, value));

    setVideos(newVideos);
  }

  function insertGlbPathValue(value) {
    const newGlbs = _.cloneDeep(glbs);
    newGlbs.push(...value);

    setGlbs(newGlbs);
  }

  function deleteFontFromFonts(fontID) {
    let newFonts = _.cloneDeep(fonts);
    if (_.isNil(newFonts)) {
      console.error("newFonts is null");
      return;
    }
    newFonts = newFonts.filter((font) => font._id !== fontID);
    setFonts(newFonts);
  }

  function deleteSoundFromSounds(soundID) {
    let newSounds = _.cloneDeep(sounds);
    if (_.isNil(newSounds)) {
      console.error("newSounds is null");
      return;
    }
    newSounds = newSounds.filter((sound) => sound._id !== soundID);
    setSounds(newSounds);
  }

  function deleteGlbFromGlbs(glbID) {
    let newGlbs = _.cloneDeep(glbs);
    if (_.isNil(newGlbs)) {
      console.error("newGlbs is null");
      return;
    }
    newGlbs = newGlbs.filter((glb) => glb._id !== glbID);
    setGlbs(newGlbs);
  }

  function deleteVideoFromVideos(videoID) {
    let newVideos = _.cloneDeep(videos);
    if (_.isNil(newVideos)) {
      console.error("newVideos is null");
      return;
    }
    newVideos = newVideos.filter((video) => video._id !== videoID);
    setVideos(newVideos);
  }

  function deleteAnimationSetFromAtlases(animationSetID) {
    let newAtlases = _.cloneDeep(atlases);
    if (_.isNil(newAtlases)) {
      console.error("newAtlases is null");
      return;
    }
    newAtlases = newAtlases.filter((atlas) => atlas.animationSet !== animationSetID);
    setAtlases(newAtlases);
  }

  function deleteAnimationSetFromSpines(animationSetID) {
    let newSpines = _.cloneDeep(spines);
    if (_.isNil(newSpines)) {
      console.error("newSpines is null");
      return;
    }
    newSpines = newSpines.filter((spine) => spine.animationSet !== animationSetID);
    setSpines(newSpines);
  }

  function deleteFontSetFromBitmapFonts(fontSetID) {
    let newBitmapFonts = _.cloneDeep(bitmapFonts);
    if (_.isNil(newBitmapFonts)) {
      console.error("newBitmapFonts is null");
      return;
    }
    newBitmapFonts = newBitmapFonts.filter((entry) => entry.fontSet !== fontSetID);
    setBitmapFonts(newBitmapFonts);
  }

  function findDefaultVersionID() {
    if (!selectedBase) {
      return;
    }
    return new Promise((resolve, reject) => {
      fetch(getServerUri("version/findDefaultVersion"), {
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          accessToken: localStorage.getItem("session.accessToken"),
          baseID: String(selectedBase?._id),
          companyID: String(userCompany?._id)
        })
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((fetchedVersion) => {
              setDefaultVersion(fetchedVersion);
              setDefaultVersionID(fetchedVersion?.versionID);
              resolve(fetchedVersion);
            });
          } else {
            response
              .text()
              .then((err) => reject(err))
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => reject(err));
    });
  }

  function addDefaultVersionImagesToGameConfig(gameConfig, defaultVersionInfo) {
    let newGameConfig = _.cloneDeep(gameConfig);

    const activeBase = _.has(selectedBase, "predefinedGameComponents") ? selectedModifiedBase : selectedBase;
    activeBase.versionSettings.components.forEach((component, index) => {
      component.settings.forEach((setting) => {
        const childComponents = _.get(setting, "components", []);
        childComponents.forEach((childComponent) => {
          childComponent.settings.forEach((childSetting) => {
            if (childSetting.editorType === "selectorImage") {
              let images = media.images.filter((image) => image.bucket === childSetting.bucket);

              const defaultVersionImageId = _.get(
                defaultVersionInfo,
                `gameConfig.components.${childComponent.id}.${childSetting.path}`
              )[0]?._id;
              let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);

              imageIndex = imageIndex > 0 ? imageIndex : 0;

              let firstImage = _.clone(images[imageIndex]);
              if (images.length > 0) {
                _.set(firstImage, "destination", _.get(childSetting, "destination"));
                _.set(firstImage, "path", _.get(childSetting, "path"));
                _.set(newGameConfig, `components.${childComponent.id}.${childSetting.path}[0]`, firstImage);
              }
            } else if (childSetting.editorType === "selectorAtlas") {
              let filteredAtlases = atlases.filter((atlas) => atlas.bucket === childSetting.bucket);

              const defaultVersionAnimationSet = _.get(
                defaultVersionInfo,
                `gameConfig.components.${childComponent.id}.${childSetting.path}`
              )[0].animationSet;
              let animationIndex = filteredAtlases.indexOf(
                filteredAtlases.filter((atlas) => atlas.animationSet == defaultVersionAnimationSet)[0]
              );
              animationIndex = animationIndex > 0 ? animationIndex : 0;

              let defaultAnimationSet = filteredAtlases.filter(
                (atlas) => atlas.animationSet === filteredAtlases[animationIndex].animationSet
              );
              if (defaultAnimationSet.length > 0) {
                //we have to deeply clone first animation set, since last selectorAtlases that has same buckets info,
                // manipulates destination info of other selectorAtlases that has same buckets info

                //deep clone of first animation set
                const firstAnimationSetDeepClone = _.cloneDeep(defaultAnimationSet);
                firstAnimationSetDeepClone.forEach((atlas) => {
                  _.set(atlas, "destination", childSetting.destinations[atlas.variant]);
                  _.set(atlas, "path", _.get(childSetting, "path"));
                });
                _.set(
                  newGameConfig,
                  `components.${childComponent.id}.${childSetting.path}`,
                  firstAnimationSetDeepClone
                );
              }
            } else if (childSetting.editorType === "selectorSpine") {
              let filteredSpines = spines.filter((spine) => spine.bucket === childSetting.bucket);

              const defaultVersionAnimationSet = _.get(
                defaultVersionInfo,
                `gameConfig.components.${childComponent.id}.${childSetting.path}`
              )[0].animationSet;
              let animationIndex = filteredSpines.indexOf(
                filteredSpines.filter((spine) => spine.animationSet == defaultVersionAnimationSet)[0]
              );
              animationIndex = animationIndex > 0 ? animationIndex : 0;

              let defaultAnimationSet = filteredSpines.filter(
                (spine) => spine.animationSet === filteredSpines[animationIndex].animationSet
              );
              if (defaultAnimationSet.length > 0) {
                //we have to deeply clone first animation set, since last selectorSpines that has same buckets info,
                // manipulates destination info of other selectorSpines that has same buckets info

                //deep clone of first animation set
                const firstAnimationSetDeepClone = _.cloneDeep(defaultAnimationSet);
                firstAnimationSetDeepClone.forEach((spine) => {
                  _.set(spine, "destination", childSetting.destinations[spine.variant]);
                  _.set(spine, "path", _.get(childSetting, "path"));
                });
                _.set(
                  newGameConfig,
                  `components.${childComponent.id}.${childSetting.path}`,
                  firstAnimationSetDeepClone
                );
              }
            }
          });
        });

        // for decision maker settings
        const childSettings = _.get(setting, "settings", []);
        childSettings.forEach((childSetting) => {
          if (childSetting.editorType === "selectorImage") {
            let images = media.images.filter((image) => image.bucket === childSetting.bucket);

            const defaultVersionImageId = _.get(
              defaultVersionInfo,
              `gameConfig.components.${component.id}.${childSetting.path}`
            )[0]?._id;
            let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);

            imageIndex = imageIndex > 0 ? imageIndex : 0;

            let firstImage = _.clone(images[imageIndex]);
            if (images.length > 0) {
              _.set(firstImage, "destination", _.get(childSetting, "destination"));
              _.set(firstImage, "path", _.get(childSetting, "path"));
              _.set(newGameConfig, `components.${component.id}.${childSetting.path}[0]`, firstImage);
            }
          }
        });

        if (setting.editorType === "selectorImage") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          const defaultVersionImageId = _.get(
            defaultVersionInfo,
            `gameConfig.components.[${component.id}].${setting.path}`
          )[0]._id;
          let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);
          imageIndex = imageIndex > 0 ? imageIndex : 0;
          let defaultImage = _.clone(images[imageIndex]);

          if (images.length > 0) {
            _.set(defaultImage, "destination", _.get(setting, "destination"));
            _.set(defaultImage, "path", _.get(setting, "path"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, defaultImage);
          }
        } else if (setting.editorType === "selectorImageFullPath") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          const defaultVersionImageId = _.get(defaultVersionInfo, `gameConfig.components.${setting.path}`)[0]?._id;
          let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);
          imageIndex = imageIndex > 0 ? imageIndex : 0;

          let defaultImage = _.clone(images[imageIndex]);
          if (images.length > 0) {
            _.set(defaultImage, "destination", _.get(setting, "destination"));
            _.set(defaultImage, "path", _.get(setting, "path"));
            _.set(newGameConfig, `components.${setting.path}[0]`, defaultImage);
          }
        } else if (setting.editorType === "selectorSound") {
          let filteredSounds = sounds.filter((sound) => sound.bucket === setting.bucket);

          const defaultVersionSoundId = _.get(defaultVersionInfo, `gameConfig.components.${setting.path}`)[0]?._id;
          let soundIndex = filteredSounds.indexOf(
            filteredSounds.filter((sound) => sound._id == defaultVersionSoundId)[0]
          );
          soundIndex = soundIndex > 0 ? soundIndex : 0;
          let defaultSound = _.clone(filteredSounds[soundIndex]);

          if (filteredSounds.length > 0) {
            _.set(defaultSound, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${setting.path}[0]`, defaultSound);
          }
        } else if (setting.editorType === "selectorFont") {
          let filteredFonts = _.clone(fonts);
          const defaultVersionFontId = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )?._id;
          let fontIndex = filteredFonts.indexOf(filteredFonts.filter((font) => font._id == defaultVersionFontId)[0]);
          fontIndex = fontIndex > 0 ? fontIndex : 0;

          let font = !_.isNil(filteredFonts[index]) ? filteredFonts[index] : filteredFonts[fontIndex];
          const defaultFont = _.cloneDeep(font);
          if (filteredFonts.length > 0) {
            _.set(defaultFont, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, defaultFont);
          }
        } else if (setting.editorType === "selectorImageSet") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          const defaultVersionImageSet = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )[0]?.imageSet;
          let imageIndex = images.indexOf(images.filter((image) => image.imageSet == defaultVersionImageSet)[0]);
          imageIndex = imageIndex > 0 ? imageIndex : 0;

          let defaultImageSet = images.filter((image) => image.imageSet === images[imageIndex].imageSet);

          if (defaultImageSet.length > 0) {
            //we have to deeply clone first image set, since last selectorImageSet that has same buckets info,
            // manipulates destination info of other selectorImageSets that has same buckets info

            //deep clone of first image set
            const firstImageSetDeepClone = _.cloneDeep(defaultImageSet);
            firstImageSetDeepClone.forEach((image) => {
              _.set(image, "destination", setting.destinations[image.variant]);
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstImageSetDeepClone);
          }
        } else if (setting.editorType === "selectorAtlas") {
          let filteredAtlases = atlases.filter((atlas) => atlas.bucket === setting.bucket);

          const defaultVersionAnimationSet = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )[0]?.animationSet;
          let animationIndex = filteredAtlases.indexOf(
            filteredAtlases.filter((atlas) => atlas.animationSet == defaultVersionAnimationSet)[0]
          );
          animationIndex = animationIndex > 0 ? animationIndex : 0;

          let defaultAnimationSet = filteredAtlases.filter(
            (atlas) => atlas.animationSet === filteredAtlases[animationIndex].animationSet
          );
          if (defaultAnimationSet.length > 0) {
            //we have to deeply clone first animation set, since last selectorAtlases that has same buckets info,
            // manipulates destination info of other selectorAtlases that has same buckets info

            //deep clone of first animation set
            const firstAnimationSetDeepClone = _.cloneDeep(defaultAnimationSet);
            firstAnimationSetDeepClone.forEach((atlas) => {
              _.set(atlas, "destination", setting.destinations[atlas.variant]);
              _.set(atlas, "path", _.get(setting, "path"));
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstAnimationSetDeepClone);
          }
        } else if (setting.editorType === "selectorSpine") {
          let filteredSpines = spines.filter((spine) => spine.bucket === setting.bucket);

          const defaultVersionAnimationSet = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )[0]?.animationSet;
          let animationIndex = filteredSpines.indexOf(
            filteredSpines.filter((spine) => spine.animationSet == defaultVersionAnimationSet)[0]
          );
          animationIndex = animationIndex > 0 ? animationIndex : 0;

          let defaultAnimationSet = filteredSpines.filter(
            (spine) => spine.animationSet === filteredSpines[animationIndex].animationSet
          );
          if (defaultAnimationSet.length > 0) {
            //we have to deeply clone first animation set, since last selectorSpines that has same buckets info,
            // manipulates destination info of other selectorSpines that has same buckets info

            //deep clone of first animation set
            const firstAnimationSetDeepClone = _.cloneDeep(defaultAnimationSet);
            firstAnimationSetDeepClone.forEach((spine) => {
              _.set(spine, "destination", setting.destinations[spine.variant]);
              _.set(spine, "path", _.get(setting, "path"));
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstAnimationSetDeepClone);
          }
        } else if (setting.editorType === "selectorVideo") {
          const filteredVideos = videos.filter((video) => video.bucket === setting.bucket);

          const defaultVersionVideoId = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )[0]?._id;
          let videoIndex = filteredVideos.indexOf(
            filteredVideos.filter((video) => video._id == defaultVersionVideoId)[0]
          );
          videoIndex = videoIndex > 0 ? videoIndex : 0;

          const defaultVideo = _.clone(filteredVideos[videoIndex]);
          if (filteredVideos.length > 0) {
            _.set(defaultVideo, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, defaultVideo);
          }
        } else if (setting.editorType === "selectorGlb") {
          const filteredGlbs = glbs.filter((glb) => glb.bucket === setting.bucket);
          const defaultVersionGlbId = _.get(
            defaultVersionInfo,
            `gameConfig.components.${component.id}.${setting.path}`
          )?.[0]?._id;
          let glbIndex = filteredGlbs.indexOf(
            filteredGlbs.filter((glb) => glb._id == defaultVersionGlbId)[0]
          );
          glbIndex = glbIndex > 0 ? glbIndex : 0;
          if (filteredGlbs.length > 0) {
            const defaultGlb = _.clone(filteredGlbs[glbIndex]);
            _.set(defaultGlb, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, defaultGlb);
          }
        }
      });
    });

    //autoplay hand initial value
    if (!_.isNil(selectedBase.recorderSettings)) {
      selectedBase.recorderSettings.components.forEach((component) => {
        component.settings.forEach((setting) => {
          if (setting.editorType === "selectorImage") {
            let images = media.images.filter((image) => image.bucket === setting.bucket);
            const defaultVersionImageId = _.get(
              defaultVersionInfo,
              `gameConfig.components.${component.id}.${setting.path}`
            )[0]._id;
            let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);
            imageIndex = imageIndex > 0 ? imageIndex : 0;
            let defaultImage = _.clone(images[imageIndex]);

            if (images.length > 0) {
              _.set(defaultImage, "destination", _.get(setting, "destination"));
              _.set(defaultImage, "path", _.get(setting, "path"));
              _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, defaultImage);
            }
          } else if (setting.editorType === "selectorImageFullPath") {
            let images = media.images.filter((image) => image.bucket === setting.bucket);
            const defaultVersionImageId = _.get(defaultVersionInfo, `gameConfig.components.${setting.path}`)[0]._id;
            let imageIndex = images.indexOf(images.filter((image) => image._id == defaultVersionImageId)[0]);
            imageIndex = imageIndex > 0 ? imageIndex : 0;
            let defaultImage = _.clone(images[imageIndex]);
            if (images.length > 0) {
              _.set(defaultImage, "destination", _.get(setting, "destination"));
              _.set(defaultImage, "path", _.get(setting, "path"));
              _.set(newGameConfig, `components.${setting.path}[0]`, defaultImage);
            }
          }
        });
      });
    }

    return newGameConfig;
  }

  function addDefaultImagesToGameConfig(gameConfig) {
    let newGameConfig = _.cloneDeep(gameConfig);

    const activeBase = _.has(selectedBase, "predefinedGameComponents")
      ? _.isNil(selectedModifiedBase)
        ? processPredefinedGameComponentsToBase(selectedBase)
        : selectedModifiedBase
      : selectedBase;
    activeBase.versionSettings.components.forEach((component, index) => {
      component.settings.forEach((setting) => {
        const childComponents = _.get(setting, "components", []);
        childComponents.forEach((childComponent) => {
          childComponent.settings.forEach((childSetting) => {
            if (childSetting.editorType === "selectorImage") {
              let images = media.images.filter((image) => image.bucket === childSetting.bucket);

              let firstImage = _.clone(images[0]);
              if (images.length > 0) {
                _.set(firstImage, "destination", _.get(childSetting, "destination"));
                _.set(firstImage, "path", _.get(childSetting, "path"));
                _.set(newGameConfig, `components.${childComponent.id}.${childSetting.path}[0]`, firstImage);
              }
            } else if (childSetting.editorType === "selectorAtlas") {
              let filteredAtlases = atlases.filter((atlas) => atlas.bucket === childSetting.bucket);

              if (filteredAtlases.length > 0) {
                let firstAnimationSet = filteredAtlases.filter(
                  (atlas) => atlas.animationSet === filteredAtlases[0].animationSet
                );
                if (firstAnimationSet.length > 0) {
                  const firstAnimationSetDeepClone = _.cloneDeep(firstAnimationSet);
                  firstAnimationSetDeepClone.forEach((atlas) => {
                    _.set(atlas, "destination", childSetting.destinations[atlas.variant]);
                    _.set(atlas, "path", _.get(childSetting, "path"));
                  });
                  _.set(newGameConfig, `components.${childComponent.id}.${childSetting.path}`, firstAnimationSetDeepClone);
                }
              }
            } else if (childSetting.editorType === "selectorSpine") {
              let filteredSpines = spines.filter((spine) => spine.bucket === childSetting.bucket);

              if (filteredSpines.length > 0) {
                let firstAnimationSet = filteredSpines.filter(
                  (spine) => spine.animationSet === filteredSpines[0].animationSet
                );
                if (firstAnimationSet.length > 0) {
                  const firstAnimationSetDeepClone = _.cloneDeep(firstAnimationSet);
                  firstAnimationSetDeepClone.forEach((spine) => {
                    _.set(spine, "destination", childSetting.destinations[spine.variant]);
                    _.set(spine, "path", _.get(childSetting, "path"));
                  });
                  _.set(newGameConfig, `components.${childComponent.id}.${childSetting.path}`, firstAnimationSetDeepClone);
                }
              }
            }
          });
        });

        // for decision maker settings
        const childSettings = _.get(setting, "settings", []);
        childSettings.forEach((childSetting) => {
          if (childSetting.editorType === "selectorImage") {
            let images = media.images.filter((image) => image.bucket === childSetting.bucket);

            let firstImage = _.clone(images[0]);
            if (images.length > 0) {
              _.set(firstImage, "destination", _.get(childSetting, "destination"));
              _.set(firstImage, "path", _.get(childSetting, "path"));
              _.set(newGameConfig, `components.${component.id}.${childSetting.path}[0]`, firstImage);
            }
          }
        });

        if (setting.editorType === "selectorImage") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          let firstImage = _.clone(images[0]);
          if (images.length > 0) {
            _.set(firstImage, "destination", _.get(setting, "destination"));
            _.set(firstImage, "path", _.get(setting, "path"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, firstImage);
          }
        } else if (setting.editorType === "selectorImageFullPath") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          let firstImage = _.clone(images[0]);
          if (images.length > 0) {
            _.set(firstImage, "destination", _.get(setting, "destination"));
            _.set(firstImage, "path", _.get(setting, "path"));
            _.set(newGameConfig, `components.${setting.path}[0]`, firstImage);
          }
        } else if (setting.editorType === "selectorSound") {
          let filteredSounds = sounds.filter((sound) => sound.bucket === setting.bucket);

          let firstSound = _.clone(filteredSounds[0]);
          if (filteredSounds.length > 0) {
            _.set(firstSound, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${setting.path}[0]`, firstSound);
          }
        } else if (setting.editorType === "selectorFont") {
          let filteredFonts = _.clone(fonts);
          let font = !_.isNil(filteredFonts[index]) ? filteredFonts[index] : filteredFonts[0];
          const firstFont = _.cloneDeep(font);
          if (filteredFonts.length > 0) {
            _.set(firstFont, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstFont);
          }
        } else if (setting.editorType === "selectorImageSet") {
          let images = media.images.filter((image) => image.bucket === setting.bucket);

          let firstImageSet = images.filter((image) => image.imageSet === images[0].imageSet);

          if (firstImageSet.length > 0) {
            //we have to deeply clone first image set, since last selectorImageSet that has same buckets info,
            // manipulates destination info of other selectorImageSets that has same buckets info

            //deep clone of first image set
            const firstImageSetDeepClone = _.cloneDeep(firstImageSet);
            firstImageSetDeepClone.forEach((image) => {
              _.set(image, "destination", setting.destinations[image.variant]);
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstImageSetDeepClone);
          }
        } else if (setting.editorType === "selectorAtlas") {
          let filteredAtlases = atlases.filter((atlas) => atlas.bucket === setting.bucket);

          let firstAnimationSet = filteredAtlases.filter(
            (atlas) => atlas.animationSet === filteredAtlases[0].animationSet
          );
          if (firstAnimationSet.length > 0) {
            //we have to deeply clone first animation set, since last selectorAtlases that has same buckets info,
            // manipulates destination info of other selectorAtlases that has same buckets info

            //deep clone of first animation set
            const firstAnimationSetDeepClone = _.cloneDeep(firstAnimationSet);
            firstAnimationSetDeepClone.forEach((atlas) => {
              _.set(atlas, "destination", setting.destinations[atlas.variant]);
              _.set(atlas, "path", _.get(setting, "path"));
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstAnimationSetDeepClone);
          }
        } else if (setting.editorType === "selectorSpine") {
          let filteredSpines = spines.filter((spine) => spine.bucket === setting.bucket);

          let firstAnimationSet = filteredSpines.filter(
            (spine) => spine.animationSet === filteredSpines[0].animationSet
          );
          if (firstAnimationSet.length > 0) {
            //we have to deeply clone first animation set, since last selectorSpines that has same buckets info,
            // manipulates destination info of other selectorSpines that has same buckets info

            //deep clone of first animation set
            const firstAnimationSetDeepClone = _.cloneDeep(firstAnimationSet);
            firstAnimationSetDeepClone.forEach((spine) => {
              _.set(spine, "destination", setting.destinations[spine.variant]);
              _.set(spine, "path", _.get(setting, "path"));
            });
            _.set(newGameConfig, `components.${component.id}.${setting.path}`, firstAnimationSetDeepClone);
          }
        } else if (setting.editorType === "selectorVideo") {
          const filteredVideos = videos.filter((video) => video.bucket === setting.bucket);

          const firstVideo = _.clone(filteredVideos[0]);
          if (filteredVideos.length > 0) {
            _.set(firstVideo, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, firstVideo);
          }
        } else if (setting.editorType === "selectorGlb") {
          const filteredGlbs = glbs.filter((glb) => glb.bucket === setting.bucket);
          if (filteredGlbs.length > 0) {
            const firstGlb = _.clone(filteredGlbs[0]);
            _.set(firstGlb, "destination", _.get(setting, "destination"));
            _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, firstGlb);
          }
        }
      });
    });

    //autoplay hand initial value
    if (!_.isNil(selectedBase.recorderSettings)) {
      selectedBase.recorderSettings.components.forEach((component) => {
        component.settings.forEach((setting) => {
          if (setting.editorType === "selectorImage") {
            let images = media.images.filter((image) => image.bucket === setting.bucket);
            let firstImage = _.clone(images[0]);
            if (images.length > 0) {
              _.set(firstImage, "destination", _.get(setting, "destination"));
              _.set(firstImage, "path", _.get(setting, "path"));
              _.set(newGameConfig, `components.${component.id}.${setting.path}[0]`, firstImage);
            }
          } else if (setting.editorType === "selectorImageFullPath") {
            let images = media.images.filter((image) => image.bucket === setting.bucket);
            let firstImage = _.clone(images[0]);
            if (images.length > 0) {
              _.set(firstImage, "destination", _.get(setting, "destination"));
              _.set(firstImage, "path", _.get(setting, "path"));
              _.set(newGameConfig, `components.${setting.path}[0]`, firstImage);
            }
          }
        });
      });
    }

    return newGameConfig;
  }

  function makeid(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**
   * Creates snackbar for notifications
   * Max count is 3
   * @param {string} message text written in snackbar label
   * @param {string} variant success|error|warning|info
   * @returns snackbar object
   */
  function createSnackbar(message, variant, isPersist, onActionClick, actionLabel, duration) {
    let vertical = "bottom";
    let horizontal = "center";

    let opts = {
      key: !isPersist ? "sameKey" : makeid(10),
      variant,
      anchorOrigin: {
        vertical,
        horizontal
      },
      preventDuplicate: true,
      // Explicit duration wins; otherwise warnings linger longer than the rest.
      autoHideDuration: duration != null ? duration : variant === "warning" ? 10000 : 5000,
      TransitionComponent: Slide,
      persist: isPersist
    };
    if (onActionClick) {
      opts.action = () => (
        <button
          onClick={onActionClick}
          style={{ color: "#404040", background: "none", border: "1px solid #404040", borderRadius: "4px", cursor: "pointer", padding: "4px 10px", fontSize: "0.8rem", marginRight: "8px" }}
        >
          {actionLabel || "More info"}
        </button>
      );
    }
    return enqueueSnackbar(message, opts);
  }

  // A snapshot editor base swaps the version editor out for the snapshot
  // editor: same shell (account, game picker, base picker), different body.
  // A pe3d base does the same with its own variant editor (components/pe3d/).
  const isSnapshotEditor = isSnapshotEditorBase(selectedBase);
  const isPe3d = isPe3dBase(selectedBase);
  // What the pe3d export and demo link need to count plan usage, as the other export dialogs do.
  const pe3dAccount = { userCompany, setUserCompany, plans, getPlanIndex };
  // Collapsing the preview is a snapshot-editor behaviour only; the other two
  // product modes keep the plain drag they have always had.
  isSnapshotEditorRef.current = isSnapshotEditor;

  // A company can legitimately reach nothing: a new one, before a superAdmin
  // grants it any bases. There is then no base to select, and waiting for one
  // would spin forever — the shell renders with an empty game list instead.
  const hasNoContent =
    areGamesLoaded && areBasesLoaded && _.size(games) === 0 && _.size(galleryGames) === 0 && _.size(bases) === 0;

  let isLoading =
    !isTokenValidated ||
    !areGamesLoaded ||
    !areBasesLoaded ||
    // Everything below (version tree, dialogs, editor) dereferences the selected
    // base on mount, so keep the spinner up until one is actually selected.
    (!hasNoContent && _.isNil(selectedBase)) ||
    !areVersionsLoaded ||
    !arePlansLoaded ||
    !arePermissionsLoaded;
  if (areVersionsLoaded && _.size(versions) > 0) {
    isLoading &= isPreviewLoaded;
  }
  if (isLoading) {
    return circularProgressDiv();
  } else if (_.isNil(userPermissions)) {
    return <Redirect to="/login" />;
  } else {
    return (
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        <BannerSwitchedCompany
          isSwitchedCompany={isSwitchedCompany}
          companyName={_.get(userCompany, "name", null)}
          createSnackbar={createSnackbar}
        />
        <div id={"homeDiv"} className={classes.homeDiv}>
        <div id={"column1"} className={classes.column1}>
          <div id={"column1Top"} ref={column1TopRef} className={classes.column1Top}>
            <div id="gamesOuter_div" style={{ flex: 1 }}>
              <ImageAccountItem
                classes={classes}
                onClick={() => {
                  setIsAccountInfoVisible(true);
                }}
              />
              <DialogAccountSettings
                isAccountInfoVisible={isAccountInfoVisible}
                setIsAccountInfoVisible={setIsAccountInfoVisible}
                initialSelectedPage={accountSettingsInitialPage}
                plans={plans}
                games={games.concat(galleryGames)}
                classes={classes}
                userCompany={userCompany}
                userName={localStorage.getItem("user.username")}
                userEmail={localStorage.getItem("user.emailAddress")}
                numberOfBases={numberOfBases}
                onClose={() => {
                  setIsAccountInfoVisible(false);
                }}
                onRuntimeChanged={fetchGames}
                onCompanyUpdated={setUserCompany}
                isAdmin={isAdmin}
                userRole={userRole}
                canManageRuntimeBases={canManageRuntimeBases}
                canGrantBasesToCompanies={canGrantBasesToCompanies}
                canGrantPe3dGames={canGrantPe3dGames}
                switchTargets={switchTargets}
                userPermissions={userPermissions}
                appEnv={appEnv}
                createSnackbar={createSnackbar}
                getPlanIndex={getPlanIndex}
                selectedVersion={selectedVersion}
                selectedGame={selectedGame}
                selectedBase={selectedBase}
                setIsVersionBeingUpdatedFalse={setIsVersionBeingUpdatedFalse}
              />
              <StickyVersionUpdateWarning
                userPermissions={userPermissions}
                appEnv={appEnv}
                createSnackbar={createSnackbar}
                suppress={isAccountInfoVisible}
                onOpen={() => {
                  setAccountSettingsInitialPage(6);
                  setIsAccountInfoVisible(true);
                }}
              />
              {_.get(userCompany, "hasPlayableGallery", false) && (
                <PlayableGallery
                  classes={classes}
                  galleryGames={galleryGames}
                  selectedGame={selectedGame}
                  setSelectedGame={setSelectedGame}
                  selectedVersion={selectedVersion}
                  versions={versions}
                  setVersions={setVersions}
                  userPermissions={userPermissions}
                  createSnackbar={createSnackbar}
                />
              )}
              <SelectorGame
                shouldLog={true}
                items={games}
                classes={classes}
                value={selectedGameID}
                setValue={setSelectedGame}
                selectedVersion={selectedVersion}
                versions={versions}
                setVersions={setVersions}
                userPermissions={userPermissions}
                persistVersionBeforeSwitch={persistVersionBeforeSwitch}
              />
            </div>
          </div>
          <BasicPopover height="50px" />
        </div>
        {_.isNil(selectedBase) ? (
          <div className={classes.emptyContent}>
            <Typography variant="body2">
              There is no game that is reachable to you. If you think this is a mistake, contact
              Administrator to grant access.
            </Typography>
          </div>
        ) : (
          <>
        <div className={classes.resizableDiv}>
          <div id={"column2"} className={classes.column2}>
            <div id={"column2Top"} className={classes.column2Top}>
              <div style={{ flex: 1 }}>
                <Typography id="plusIconTypography" style={{ fontSize: "15px" }}>
                  {_.get(selectedGame, "title", "")}
                </Typography>
                <BasePicker
                  items={bases}
                  classes={classes}
                  selectedItem={selectedBase}
                  setSelectedItem={setSelectedBase}
                  setSelectedModifiedBase={setSelectedModifiedBase}
                  shouldLog={true}
                  selectedVersion={selectedVersion}
                  versions={versions}
                  setVersions={setVersions}
                  userPermissions={userPermissions}
                  persistVersionBeforeSwitch={persistVersionBeforeSwitch}
                ></BasePicker>
              </div>
              {/* Everything from here to the end of column2Top is version
                  machinery — create/rename/duplicate/delete and their dialogs,
                  all of it backed by mongo versions and the hierarchy document.
                  The snapshot editor has none of those concepts, and pe3d
                  keeps its own in its variant list. */}
              {!isSnapshotEditor && !isPe3d && (
                <>
                  <VersionStorageOptions
                    setIsInsertVersionDialogOpen={setIsInsertVersionDialogOpen}
                    setIsFolderVersionDialogOpen={setIsFolderVersionDialogOpen}
                    userPermissions={userPermissions}
                    createSnackbar={createSnackbar}
                  />
                  <VersionSelectorOptions
                    setIsRenameVersionDialogOpen={setIsRenameVersionDialogOpen}
                    setIsRenameFolderDialogOpen={setIsRenameFolderDialogOpen}
                    userID={localStorage.getItem("user.id")}
                    setIsDeleteDialogOpen={setIsDeleteDialogOpen}
                    setIsDuplicateDialogOpen={setIsDuplicateDialogOpen}
                    setIsDownloadDialogOpen={setIsDownloadDialogOpen}
                    setIsDeleteAllDialogOpen={setIsDeleteAllDialogOpen}
                    setIsFolderDialogOpen={setIsFolderDialogOpen}
                    userPermissions={userPermissions}
                    menuLayout={menuLayout}
                    createSnackbar={createSnackbar}
                    selectedVersion={selectedVersion}
                    selectedBase={selectedBase}
                    versions={versions}
                    setVersions={setVersions}
                    setSelectedVersion={setSelectedVersion}
                    fetchVersions={fetchVersions}
                  />
                  <DialogVersionInsert
                    processPredefinedGameComponentsToBase={processPredefinedGameComponentsToBase}
                    open={isInsertVersionDialogOpen}
                    treeIsSorted={treeIsSorted}
                    selectedGame={selectedGame}
                    selectedBase={selectedBase}
                    selectedModifiedBase={selectedModifiedBase}
                    selectedVersion={selectedVersion}
                    companyID={localStorage.getItem("user.companyID")}
                    setSearchTerm={(value) => {
                      setSearchTerm(value);
                    }}
                    setSelectedVersion={(value) => {
                      setSelectedVersion(value);
                    }}
                    setSortAgain={(value) => {
                      setSortAgain(value);
                    }}
                    setSelectedFolderId={(value) => {
                      setSelectedFolderId(value);
                    }}
                    setOpen={(value) => {
                      setIsInsertVersionDialogOpen(value);
                    }}
                    setDefaultVersion={(value) => {
                      setDefaultVersion(value);
                    }}
                    setInsertNewVersion={(value) => {
                      setInsertNewVersion(value);
                    }}
                    selectedFolderId={selectedFolderId}
                    hierarchyEnabled={hierarchyEnabled}
                    fetchVersions={fetchVersions}
                    insertNewVersion={insertNewVersion}
                    createSnackbar={createSnackbar}
                    defaultVersionUpdated={defaultVersionUpdated}
                    defaultVersion={
                      defaultVersion ? defaultVersion : versions.filter((version) => version._id == defaultVersionID)[0]
                    }
                    persistVersionPathValue={persistVersionPathValue}
                  />
                  <DialogFolderInsert
                    open={isFolderVersionDialogOpen}
                    selectedGame={selectedGame}
                    selectedBase={selectedBase}
                    selectedVersion={selectedVersion}
                    versions={versions}
                    hierarchyEnabled={hierarchyEnabled}
                    selectedFolderId={selectedFolderId}
                    setHierarchyEnabled={setHierarchyEnabled}
                    setVersionHierarchy={setVersionHierarchy}
                    companyID={localStorage.getItem("user.companyID")}
                    setSearchTerm={(value) => {
                      setSearchTerm(value);
                    }}
                    setOpen={(value) => {
                      setIsFolderVersionDialogOpen(value);
                    }}
                    createSnackbar={createSnackbar}
                    //folderları renderlamak için oluşturulan global
                    setUpdateTreeOpen={(value) => {
                      setUpdateTreeOpen(value);
                    }}
                  />
                  <DialogVersionDelete
                    isOpen={isDeleteDialogOpen}
                    deleteVersionFromView={(versionID, isMultiple, multipleVersion, folderId) => {
                      try {
                        deleteVersionFromView(versionID, isMultiple, multipleVersion, folderId);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    setSearchTerm={(value) => {
                      setSearchTerm(value);
                    }}
                    companyID={localStorage.getItem("user.companyID")}
                    selectedVersion={selectedVersion}
                    setRenameFolderName={renameFolderName}
                    setSelectedFolderId={(value) => {
                      setSelectedFolderId(value);
                    }}
                    setIsOpen={(value) => {
                      setIsDeleteDialogOpen(value);
                    }}
                    setInsertNewVersion={(value) => {
                      setInsertNewVersion(value);
                    }}
                    setVersionHierarchy={setDialogVersionHierarchy}
                    setDefaultVersionUpdated={(value) => {
                      setDefaultVersionUpdated(value);
                    }}
                    selectedFolderId={selectedFolderId}
                    hierarchyEnabled={hierarchyEnabled}
                    selectedBase={selectedBase}
                    createSnackbar={createSnackbar}
                    userPermissions={userPermissions}
                    defaultVersion={
                      defaultVersion ? defaultVersion : versions.filter((version) => version._id == defaultVersionID)[0]
                    }
                    defaultVersionUpdated={defaultVersionUpdated}
                  ></DialogVersionDelete>
                  <DialogDeleteAllVersions
                    isOpen={isDeleteAllDialogOpen}
                    deleteVersionFromView={(versionID, isMultiple, multipleVersion) => {
                      try {
                        deleteVersionFromView(versionID, isMultiple, multipleVersion);
                      } catch (err) {
                        console.error(err);
                      }
                    }}
                    companyID={localStorage.getItem("user.companyID")}
                    userID={localStorage.getItem("user.id")}
                    selectedVersion={selectedVersion}
                    setRenameFolderName={renameFolderName}
                    setSelectedFolderId={(value) => {
                      setSelectedFolderId(value);
                    }}
                    setInsertNewVersion={(value) => {
                      setInsertNewVersion(value);
                    }}
                    setVersionHierarchy={(value) => {
                      setUpdateTreeOpen(value);
                    }}
                    setIsOpen={(value) => {
                      setIsDeleteAllDialogOpen(value);
                    }}
                    selectedFolderId={selectedFolderId}
                    selectedBase={selectedBase}
                    createSnackbar={createSnackbar}
                    userPermissions={userPermissions}
                  ></DialogDeleteAllVersions>
                  {menuLayout ? (
                    <DialogVersionDuplicate
                      onClose={(value) => {
                        setIsDuplicateDialogOpen(value);
                      }}
                      isOpen={isDuplicateDialogOpen}
                      setVersionHierarchy={setDialogVersionHierarchy}
                      insertDuplicatedVersion={insertDuplicatedVersion}
                      setSearchTerm={(value) => {
                        setSearchTerm(value);
                      }}
                      companyID={localStorage.getItem("user.companyID")}
                      menuLayout={menuLayout}
                      selectedVersion={selectedVersion}
                      selectedBase={selectedBase}
                      hierarchyEnabled={hierarchyEnabled}
                      userCompany={userCompany}
                      setUserCompany={setUserCompany}
                      fetchVersions={fetchVersions}
                      setRenameFolderName={renameFolderName}
                      setSelectedVersion={setSelectedVersion}
                      selectedGame={selectedGame}
                      classes={props.classes}
                      createSnackbar={createSnackbar}
                    ></DialogVersionDuplicate>
                  ) : (
                    <DialogFolderDuplicate
                      onClose={(value) => {
                        setIsFolderDialogOpen(value);
                      }}
                      setRenameFolderName={renameFolderName}
                      setVersionHierarchy={(value) => {
                        setUpdateTreeOpen(value);
                      }}
                      setSearchTerm={(value) => {
                        setSearchTerm(value);
                      }}
                      menuLayout={menuLayout}
                      selectedFolderId={selectedFolderId}
                      updateHierarchyFolder={(value) => {
                        setVersionHierarchy(value);
                      }}
                      setSelectedFolderId={(value) => {
                        setSelectedFolderId(value);
                      }}
                      companyID={localStorage.getItem("user.companyID")}
                      //baseID={baseIDProps}
                      isOpen={isFolderDialogOpen}
                      //selecteFolderId={selectedFolderId}
                      selectedVersion={selectedVersion}
                      selectedBase={selectedBase}
                      hierarchyEnabled={hierarchyEnabled}
                      userCompany={userCompany}
                      setUserCompany={setUserCompany}
                      fetchVersions={fetchVersions}
                      setRenameFolderName={renameFolderName}
                      setSelectedVersion={setSelectedVersion}
                      selectedGame={selectedGame}
                      classes={props.classes}
                      createSnackbar={createSnackbar}
                    ></DialogFolderDuplicate>
                  )}

                  <DialogVersionRename
                    open={isRenameVersionDialogOpen}
                    selectedGame={selectedGame}
                    setSearchTerm={(value) => {
                      setSearchTerm(value);
                    }}
                    selectedBase={selectedBase}
                    hierarchyEnabled={hierarchyEnabled}
                    selectedVersion={selectedVersion}
                    companyID={localStorage.getItem("user.companyID")}
                    setOpen={(value) => {
                      setIsRenameVersionDialogOpen(value);
                    }}
                    setRenameVersionName={(value) => {
                      setRenameVersionName(value);
                    }}
                    renameVersion={(newVersionName) => {
                      const newVersions = _.clone(versions);
                      newVersions[newVersions.indexOf(newVersions.filter((e) => e._id === selectedVersion._id)[0])].title =
                        newVersionName;
                      newVersions[
                        newVersions.indexOf(newVersions.filter((e) => e._id === selectedVersion._id)[0])
                      ].dateUpdated = new Date();
                      console.log({
                        messages: "version renamed. the array is: ",
                        newVersions
                      });

                      setVersions(newVersions);

                      if (_.get(selectedBase, "playEngineInstance", false)) {
                        const versionID = String(selectedVersion._id);
                        setSelectedVersion((prev) =>
                          prev && String(prev._id) === versionID ? { ...prev, title: newVersionName } : prev
                        );
                        setVersionHierarchy((prev) => {
                          const next = renameVersionInTree(prev, versionID, newVersionName);
                          if (hierarchyEnabled) {
                            void saveHierarchy(
                              selectedBase._id,
                              localStorage.getItem("user.companyID"),
                              next
                            );
                          }
                          return next;
                        });
                      }

                      ReactGA.event({
                        category: "Version",
                        action: "Version Updated",
                        label:
                          "game: " +
                          selectedGame.title +
                          ", base: " +
                          selectedBase.title +
                          ", version: " +
                          selectedVersion.title,
                        dimension1: localStorage.getItem("user.id")
                      });
                      ReactGA4.event({
                        category: "Version",
                        action: "Version Updated",
                        label:
                          "game: " +
                          selectedGame.title +
                          ", base: " +
                          selectedBase.title +
                          ", version: " +
                          selectedVersion.title,
                        dimension1: localStorage.getItem("user.id")
                      });
                    }}
                    createSnackbar={createSnackbar}
                    setSelectedVersionPathValue={setSelectedVersionPathValue}
                  />
                  <DialogFolderRename
                    selectedFolderId={selectedFolderId}
                    open={isRenameFolderDialogOpen}
                    selectedGame={selectedGame}
                    selectedBase={selectedBase}
                    selectedVersion={selectedVersion}
                    companyID={localStorage.getItem("user.companyID")}
                    isOpen={isRenameFolderDialogOpen}
                    setOpen={(value) => {
                      setIsRenameFolderDialogOpen(value);
                    }}
                    setVersionHierarchy={(value) => {
                      setUpdateTreeOpen(value);
                    }}
                    //get props.node from custom node
                    setRenameFolderName={renameFolderName}
                    setUpdateTreeOpen={(value) => {
                      setUpdateTreeOpen(value);
                    }}
                    renameVersion={(newVersionName) => {
                      const newVersions = _.clone(versions);
                      newVersions[newVersions.indexOf(newVersions.filter((e) => e._id === selectedVersion._id)[0])].title =
                        newVersionName;
                      newVersions[
                        newVersions.indexOf(newVersions.filter((e) => e._id === selectedVersion._id)[0])
                      ].dateUpdated = new Date();
                      console.log({
                        messages: "version renamed. the array is: ",
                        newVersions
                      });

                      setVersions(newVersions);

                      ReactGA.event({
                        category: "Version",
                        action: "Version Updated",
                        label:
                          "game: " +
                          selectedGame.title +
                          ", base: " +
                          selectedBase.title +
                          ", version: " +
                          selectedVersion.title,
                        dimension1: localStorage.getItem("user.id")
                      });
                      ReactGA4.event({
                        category: "Version",
                        action: "Version Updated",
                        label:
                          "game: " +
                          selectedGame.title +
                          ", base: " +
                          selectedBase.title +
                          ", version: " +
                          selectedVersion.title,
                        dimension1: localStorage.getItem("user.id")
                      });
                    }}
                    createSnackbar={createSnackbar}
                    setSelectedVersionPathValue={setSelectedVersionPathValue}
                  />
                </>
              )}
            </div>
            {isSnapshotEditor ? (
              <SnapshotList editor={snapshotEditor} createSnackbar={createSnackbar} />
            ) : isPe3d ? (
              <Pe3dVariantList
                editor={pe3dEditor}
                selectedBase={selectedBase}
                selectedGame={selectedGame}
                createSnackbar={createSnackbar}
                userPermissions={userPermissions}
                account={pe3dAccount}
                canGrantGames={canGrantPe3dGames}
              />
            ) : (
              <CustomDragComponent
                versionHierarchy={versionHierarchy}
                setSortedTree={(value) => {
                  setSortedTree(value);
                }}
                heightInPx={heightInPx}
                searchTerm={searchTerm}
                sortAgain={sortAgain}
                baseID={baseIDProps}
                newVersionHierarchy={props.versionHierarchy}
                versions={versions}
                treeUpdate={isUpdateTreeOpen}
                selectedBase={selectedBase}
                selectedGame={selectedGame}
                createSnackbar={createSnackbar}
                companyID={localStorage.getItem("user.companyID")}
                versionUpdate={isInsertNewVersion}
                versionRename={renameVersionName}
                updateHierarchyFolder={(value) => {
                  setVersionHierarchy(value);
                }}
                selectedFolder={(value) => {
                  setSelectedFolderId(value);
                }}
                setVersions={setVersions}
                selectedVersion={selectedVersion}
                selectedFolderId={selectedFolderId}
                hierarchyEnabled={hierarchyEnabled}
                setValue={setSelectedVersion}
                setSelectedVersionPathValueWithVersion={setSelectedVersionPathValueWithVersion}
                persistVersionBeforeSwitch={persistVersionBeforeSwitch}
                userPermissions={userPermissions}
                defaultVersion={defaultVersion}
                defaultVersionUpdated={defaultVersionUpdated}
                setIsDialogCircularProgressOpen={setIsDialogCircularProgressOpen}
                searchBarValue={searchBarValue}
                setSearchBarValue={(value) => {
                  setSearchBarValue(value);
                }}
              ></CustomDragComponent>
            )}
          </div>
          <div
            className={classes.resizer}
            onPointerDown={startPanelResize}
            onDoubleClick={stepPanelWidth}
          ></div>
        </div>
        <div style={{ width: "1000px" }} className={classes.resizableDiv}>
          {isSnapshotEditor ? (
            <SnapshotPreview editor={snapshotEditor} createSnackbar={createSnackbar} />
          ) : isPe3d ? (
            <Pe3dPreview
              editor={pe3dEditor}
              selectedBase={selectedBase}
              selectedGame={selectedGame}
              createSnackbar={createSnackbar}
              userPermissions={userPermissions}
              account={pe3dAccount}
              isPortrait={newSetPortrait}
              setIsPortrait={setPortrait}
            />
          ) : (
            <GamePreview
              selectedGame={selectedGame}
              selectedBase={selectedBase}
              setSelectedBase={setSelectedBase}
              selectedModifiedBase={selectedModifiedBase}
              setSelectedModifiedBase={setSelectedModifiedBase}
              predefinedGameComponents={predefinedGameComponents}
              totalSizeValue={totalSizeValue}
              selectedVersion={selectedVersion}
              userCompany={userCompany}
              localizationLanguage={localizationLanguage}
              setUserCompany={setUserCompany}
              applyPreview={applyPreview}
              iFrameId={iFrameId}
              versionsAreFetched={versionsAreFetched}
              prevButton={prevButton}
              setValue={setSelectedVersion}
              versionUpdate={isInsertNewVersion}
              versions={versions}
              media={media}
              atlases={atlases}
              spines={spines}
              bitmapFonts={bitmapFonts}
              sounds={sounds}
              fonts={fonts}
              videos={videos}
              setPortrait={(value) => {
                setPortrait(value);
              }}
              fetchVersions={fetchVersions}
              setSelectedVersion={setSelectedVersion}
              classes={classes}
              deleteVersionFromView={(versionID) => {
                try {
                  deleteVersionFromView(versionID);
                } catch (err) {
                  console.error(err);
                }
              }}
              versionRename={renameVersionName}
              isPreviewLoaded={isPreviewLoaded}
              setIsPreviewLoaded={setIsPreviewLoaded}
              isPreviewFullScreen={props.isPreviewFullScreen}
              shouldLog={true}
              setSelectedVersionPathValue={setSelectedVersionPathValue}
              saveVersionAndApplyPreview={saveVersionAndApplyPreview}
              refresh={refresh}
              createSnackbar={createSnackbar}
              plans={plans}
              getPlanIndex={getPlanIndex}
              userPermissions={userPermissions}
              setIsDownloadingPlayable={setIsDownloadingPlayable}
              versionHierarchy={versionHierarchy}
            ></GamePreview>
          )}
          <div
            className={classes.resizer}
            onPointerDown={startPanelResize}
            onDoubleClick={stepPanelWidth}
          ></div>
        </div>

        {!isSnapshotEditor && !isPe3d && (
          <GameConfig
            selectedGame={selectedGame}
            selectedBase={selectedBase}
            selectedModifiedBase={selectedModifiedBase}
            setSelectedModifiedBase={setSelectedModifiedBase}
            predefinedGameComponents={predefinedGameComponents}
            setTotalSize={(value) => {
              setTotalSize(value);
            }}
            setDefaultVersionUpdated={(value) => {
              setDefaultVersionUpdated(value);
            }}
            selectedVersion={selectedVersion}
            userCompany={userCompany}
            setUserCompany={setUserCompany}
            refreshCompany={fetchCompanyPermissions}
            agentCompany={agentCompany}
            refreshAgentCompany={fetchCompanyPermissions}
            media={media}
            areMediaLoaded={areMediaLoaded}
            atlases={atlases}
            spines={spines}
            bitmapFonts={bitmapFonts}
            newSetPortrait={newSetPortrait}
            localizationLanguage={localizationLanguage}
            setLocalizationLanguage={(value) => {
              setLocalizationLanguage(value);
            }}
            setSearchBarValue={(value) => {
              setSearchBarValue(value);
            }}
            areAtlasesLoaded={areAtlasesLoaded}
            areSpinesLoaded={areSpinesLoaded}
            areBitmapFontsLoaded={areBitmapFontsLoaded}
            sounds={sounds}
            areSoundsLoaded={areSoundsLoaded}
            fonts={fonts}
            areFontsLoaded={areFontsLoaded}
            videos={videos}
            areVideosLoaded={areVideosLoaded}
            glbs={glbs}
            isPreviewLoaded={isPreviewLoaded}
            classes={classes}
            iFrameId={iFrameId}
            versionRename={renameVersionName}
            setIsPreviewFullScreen={props.setIsPreviewFullScreen}
            setSelectedVersionPathValue={setSelectedVersionPathValue}
            persistVersionPathValue={persistVersionPathValue}
            patchVersionFields={patchVersionFields}
            addDefaultImagesToGameConfig={addDefaultImagesToGameConfig}
            addDefaultVersionImagesToGameConfig={addDefaultVersionImagesToGameConfig}
            insertMediaPathValue={insertMediaPathValue}
            insertAtlasPathValue={insertAtlasPathValue}
            insertSpinePathValue={insertSpinePathValue}
            insertBitmapFontPathValue={insertBitmapFontPathValue}
            insertSoundPathValue={insertSoundPathValue}
            insertFontPathValue={insertFontPathValue}
            insertVideoPathValue={insertVideoPathValue}
            insertGlbPathValue={insertGlbPathValue}
            defaultVersion={
              defaultVersion ? defaultVersion : versions.filter((version) => version._id == defaultVersionID)[0]
            }
            doRefresh={doRefresh}
            fetchVersions={fetchVersions}
            setSelectedVersion={setSelectedVersion}
            isRecordingStarted={props.isRecordingStarted}
            setIsRecordingStarted={props.setIsRecordingStarted}
            isRecorderEnabled={isRecorderEnabled}
            createSnackbar={createSnackbar}
            maxInnerHeight={maxInnerHeight}
            plans={plans}
            deleteImageFromMedia={deleteImageFromMedia}
            deleteImageSetFromMedia={deleteImageSetFromMedia}
            deleteFontFromFonts={deleteFontFromFonts}
            deleteSoundFromSounds={deleteSoundFromSounds}
            deleteVideoFromVideos={deleteVideoFromVideos}
            deleteGlbFromGlbs={deleteGlbFromGlbs}
            deleteAnimationSetFromAtlases={deleteAnimationSetFromAtlases}
            deleteAnimationSetFromSpines={deleteAnimationSetFromSpines}
            deleteFontSetFromBitmapFonts={deleteFontSetFromBitmapFonts}
            userPermissions={userPermissions}
            getPlanIndex={getPlanIndex}
            setIsDialogConfirmRefreshOpen={setIsDialogConfirmRefreshOpen}
            setIsDialogCircularProgressOpen={setIsDialogCircularProgressOpen}
            getDefaultVersion={getDefaultVersion}
            setDefaultVersion={(value) => {
              setDefaultVersion(value);
            }}
            defaultVersionUpdated={defaultVersionUpdated}
            searchBarValue={searchBarValue}
            versions={versions}
            isAdmin={isAdmin}
          />
        )}
        {isPe3d && (
          <Pe3dConfig
            editor={pe3dEditor}
            userPermissions={userPermissions}
            createSnackbar={createSnackbar}
            userCompany={userCompany}
            isAdmin={isAdmin}
            isPortrait={newSetPortrait}
          />
        )}
        {isSnapshotEditor && (
          <SnapshotConfig
            editor={snapshotEditor}
            selectedBase={selectedBase}
            selectedGame={selectedGame}
            userPermissions={userPermissions}
            createSnackbar={createSnackbar}
            isAdmin={isAdmin}
          />
        )}
        <DialogConfirmRefresh
          isOpen={isDialogConfirmRefreshOpen}
          setIsOpen={setIsDialogConfirmRefreshOpen}
          brokenAssets={brokenAssets}
          versionID={_.get(selectedVersion, "_id")}
          onRepairDone={(versionID) => {
            setBrokenAssets([]);
            return reloadSelectedVersion(versionID);
          }}
        />
        <DialogPendingCascadeWarning
          isOpen={!_.isNil(pendingCascadeInfo)}
          assetName={_.get(pendingCascadeInfo, "assetName")}
          assetType={_.get(pendingCascadeInfo, "assetType")}
          onDismiss={() => {
            try { localStorage.removeItem("pendingCascade"); } catch (e) { /* ignore */ }
            setPendingCascadeInfo(null);
          }}
        />
        <DialogCircularProgress isOpen={isDialogCircularProgressOpen} setIsOpen={setIsDialogCircularProgressOpen} />
        <DialogViewOnlyMode
          isOpen={isDialogViewOnlyModeOpen}
          setIsOpen={setIsDialogViewOnlyModeOpen}
          lastUpdatingUser={lastUpdatingUser}
        />
        <DialogFetchUpdatesOnVersion
          isOpen={isDialogFetchUpdatesOnVersionOpen}
          setIsOpen={setIsDialogFetchUpdatesOnVersionOpen}
          lastUpdatingUser={lastUpdatingUser}
        />
          </>
        )}
        </div>
      </div>
    );
  }
}
